import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import "./CandidateProfiles.css";
import {
  useJoinedCandidateMutation,
  useGetProfilEventMutation,
  useCandidateGridDatasMutation,
  useDeleteEventHistoryMutation,
  useGetTechnologiesMutation,
  usePositionDropdownMutation,
  useSelectedJobPositionMutation,
  useViewAllReferralCandidateMutation,
  useViewCandidateHistoryMutation,
  useViewInternalReferralCandidateMutation,
  useEventDropDownQuery,
} from "../../redux/candidateprofiles/candidateprofiles.api";
import { useSelector } from "react-redux";
import { useEffect, useState, useContext } from "react";
import {
  Avatar,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  Icon,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Pagination,
  Select,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Tab,
  Tooltip,
  Typography,
} from "@mui/material";
import MUIButton from "../../reusable_components/components/MUIButton";
import DeleteIcon from "../../assets/Icons/DeleteIcon";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import MuiButton from "../../reusable_components/components/MUIButton";
import { useNavigate } from "react-router-dom";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import ReplayIcon from "@mui/icons-material/Replay";
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AddIcon from "@mui/icons-material/Add";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import ArrowDownwardSharpIcon from "@mui/icons-material/ArrowDownwardSharp";
import ArrowUpwardSharpIcon from "@mui/icons-material/ArrowUpwardSharp";
// import DatePicker from "react-datepicker";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIconLg from "../../assets/Icons/SearchIcon";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker";
import CalendarIcon from "../../assets/Icons/CalendarIcon";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DoneOutlineOutlinedIcon from "@mui/icons-material/DoneOutlineOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import Nodata from "../../assets/nodata.jpg";
import { LuHistory } from "react-icons/lu";
import { BsDownload } from "react-icons/bs";
import handshake from "../../assets/handshake.png";
import BonusIcon from "../../assets/bonus.png";
import Folders from "../../assets/folders.png";
import PersonIcon from "@mui/icons-material/Person";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, set, useForm } from "react-hook-form";
import { useMakeCommissionManagementMutation, useMakeContractReferralCommissionMutation, useMakeReferralCommissionMutation } from "../../redux/jobpostings/jobManageEvents.api";
import Candidate from "../../assets/student.png";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import OfferedCandidate from "./OfferedCandidate";
import SelectedCandidate from "./SelectedCandidate";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ClearIcon from "@mui/icons-material/Clear";
import { CheckCircle, Person, Calculate, Payment, Close, FastForward, History, Block } from "@mui/icons-material";
import Dropdown from "../../reusable_components/components/Dropdown";
import { useEventsHistoryMutation } from "../../redux/jobpostings/jobpostings.api";
import AllCandidates from "./AllCandidates";
import salaryIcon from "../../assets/salary.png";
import captured from "../../assets/captured.png";


const CandidateProfile = () => {
  const commonFilter = JSON.parse(localStorage.getItem("commonsearchfilter"));

  const [search, setSearch] = useState(
    localStorage.getItem("candidateProfileSearchValue") || ""
  );
  const [joinedCandidateDataSearch, setJoinedCandidateDataSearch] =
    useState(localStorage.getItem("joinedCandidatesearch") || "");
  const [location, setLocation] = useState(
    commonFilter?.candidateProfiles?.address || ""
  );
  const [mobile, setMobile] = useState(
    commonFilter?.candidateProfiles?.mobileOrAlternateMobile || ""
  );
  const [email, setEmail] = useState(
    commonFilter?.candidateProfiles?.emailOrAlternateEmail || ""
  );
  const [fromDate, setFromDate] = useState(
    commonFilter?.candidateProfiles?.fromDate
      ? dayjs(commonFilter?.candidateProfiles?.fromDate)
      : null
  );
  const [toDate, setToDate] = useState(
    commonFilter?.candidateProfiles?.toDate
      ? dayjs(commonFilter?.candidateProfiles?.toDate)
      : null
  );
  const [sourcedBy, setSourcedBy] = useState(
    commonFilter?.candidateProfiles?.sourcedBy || ""
  );
  const [selectedKeywordIds, setSelectedKeywordIds] = useState(
    commonFilter?.candidateProfiles?.technologies || []
  );

  const navigate = useNavigate();
  const { Snackbar } = useContext(SnackbarContext);

  const [openContractDialog, setOpenContractDialog] = useState(false);

  const validationSchema = Yup.object().shape({
    joiningDate: Yup.string().required("Candidate joining date is required"),
    annualSalary: Yup.string()
      .required("Candidate monthly salary is required")
      .test(
        "is-positive",
        "Monthly salary must be a positive number",
        (value) => {
          if (!value) return false;
          const number = parseFloat(value);
          return !isNaN(number) && number > 0;
        }
      ),
  });

  const [isAmount, setIsAmount] = useState(false)

  const contractValidationSchema = Yup.object().shape({
    contractCandidateJoiningDate: Yup.string()
      .required("Candidate joining date is required"),

    billingRate: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .when('commissionMode', {
        is: (val) => val !== 'OTS',
        then: (schema) => schema.required("Billing rate is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    units: Yup.string().when('commissionMode', {
      is: (val) => val !== 'OTS',
      then: (schema) => schema.required("Currency is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    periodOfTime: Yup.string().when('commissionMode', {
      is: (val) => val !== 'OTS',
      then: (schema) => schema.required("Unit is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    contractOpenDate: Yup.string().when('commissionMode', {
      is: (val) => val !== 'OTS',
      then: (schema) => schema.required("Contract open date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    contractCloseDate: Yup.string().when('commissionMode', {
      is: (val) => val !== 'OTS',
      then: (schema) => schema.required("Contract closing date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    companyCommissionType: Yup.string()
      .required("Commission type is required"),

    companyCommissionAmount: isAmount
      ? Yup.string()
        .required("Commission Amount is required")
        .test(
          "is-less-than-salary",
          "Commission Amount must be less than Salary",
          function (value) {
            const { candidateAnnualSalary } = this.parent;
            if (!value || !candidateAnnualSalary) return true;
            const commission = parseFloat(value);
            const salary = parseFloat(candidateAnnualSalary);
            return !isNaN(commission) && !isNaN(salary) && commission < salary;
          }
        )
      : Yup.string().notRequired(),

    companyCommissionPercentage: !isAmount
      ? Yup.number()
        .typeError("Commission percentage is required")
        .required("Commission percentage is required")
        .min(1, "Commission percentage should be greater than 0")
        .max(100, "Commission percentage cannot exceed 100")
      : Yup.mixed()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : Number(originalValue)
        )
        .test(
          "is-valid-company-commission",
          "Commission percentage must be between 1 and 100",
          (value) => {
            if (value === undefined || value === null) return true; // allow empty
            return !isNaN(value) && value >= 1 && value <= 100;
          }
        ),

    commissionMode: Yup.string()
      .required("Commission mode is required"),
    candidateAnnualSalary: Yup.string()
      .required("Salary is required")
      .test(
        "is-positive",
        "Salary must be a positive number",
        (value) => {
          if (!value) return false;
          const number = parseFloat(value);
          return !isNaN(number) && number > 0;
        }
      ),
  });


  const resolver = yupResolver(openContractDialog ? contractValidationSchema : validationSchema);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
    setValue,
  } = useForm({
    mode: "onChange",
    resolver,
    defaultValues: {
      commissionMode: 'OTS'
    },
  });

  // API calling
  const [TableDatas] = useCandidateGridDatasMutation();
  const [joinedCandidate] = useJoinedCandidateMutation();
  const [viewcandidateHistory] = useViewCandidateHistoryMutation();
  const [addJobPostion] = usePositionDropdownMutation();
  const [selectedJobPosition] = useSelectedJobPositionMutation();
  const [deleteHistory] = useDeleteEventHistoryMutation();
  const [TableDatasForClient] = useViewAllReferralCandidateMutation();
  const [viewInternalReferralCandidate] =
    useViewInternalReferralCandidateMutation();
  const [profileEventsApi] = useGetProfilEventMutation();
  const { data: eventDropDown } = useEventDropDownQuery();
  const [makeReferralCommission] = useMakeReferralCommissionMutation();
  const [makeContractCommission] = useMakeContractReferralCommissionMutation()
  const [makeCommission] = useMakeCommissionManagementMutation()
  const [viewKeyWords] = useGetTechnologiesMutation();
  const [skills, setSkills] = useState([]);
  const [selectedKeywords, setSelectedKeywords] = useState([]);

  useEffect(() => {
    const fetchKeywords = async () => {
      try {
        const payload = {
          keywordName: "",
          page: 0,
          size: 1000,
        };
        const response = await viewKeyWords(payload).unwrap();
        setSkills(response?.response);
      } catch (error) {
        console.error("Error fetching keywords:", error);
      }
    };

    fetchKeywords();
  }, [viewKeyWords]);

  useEffect(() => {
    const Keywords = skills?.filter((keyword) =>
      selectedKeywordIds?.includes(keyword?.KeywordId)
    );
    setSelectedKeywords(Keywords);
  }, [selectedKeywordIds]);

  const [candidatesDatas, setCandidatesDatas] = useState([]);
  const [joinedCandidateDatas, setJoinedCandidateDatas] = useState([]);
  const [candidateHistory, setCandiateHistory] = useState([]);
  const [positions, setPositions] = useState([]);
  const [selectedPositionIds, setSelectedPositionIds] = useState([]);
  const [count, setCount] = useState(0);
  const [counts, setCounts] = useState(0);
  const [positionNames, setPositionNames] = useState([]);
  const [viewDialog, setViewDialog] = useState(false);
  const handleCloseViewDialog = () => setViewDialog(false);
  const [opencandidateSkills, setOpencandidateSkills] = useState(false);

  const getRandomColor = () => {
    const colors = [
      "green",
      "darkorange",
      "purple",
      "#5e09e7",
      "orangered",
      "darkgreen",
      "blue",
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const { Profile } = useSelector((state) => state.common);
  const userRole = Profile?.profile?.role;
  const isExternal = Profile?.profile?.isExternalRecruiter;

  const [page, setPage] = useState(
    +localStorage.getItem("candidateProfileNewPage") || 1
  );
  const [candidateJoinedPage, setCandidateJoinedPage] = useState(
    +localStorage.getItem("candidateProfileJoinedPage") || 1
  );
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [joinedRowsPerPage, setJoinedRowsPerPage] = useState(10);
  const [totalPagecount, setTotalPageCount] = useState(0);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [hoveredIcon, setHoveredIcon] = useState("");

  const [profileId, setProfileId] = useState("");
  const [technologies, setTechnologies] = useState("");
  const [sortingColumnDirection, setSortingColumnDirection] = useState("DESC");
  const [arrow, setArrow] = useState(false);
  const [filter, setFillter] = useState(false);
  const [showTableLoader, setShowTableLoader] = useState(false);
  const [mainEvent, setMainEvent] = useState();

  const [historytableLoder, setHistorytableLoder] = useState(false);
  const [showClearFilter, setShowClearFilter] = useState(false);
  const [triggerApi, setTriggerApi] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [profileEvents, setProfileEvents] = useState([]);
  const [events, setEvents] = useState("");
  const [dropdownEvent, setDropdownEvent] = useState([]);
  const [eventOptions, setEventOptions] = useState([]);
  const selectedCandidate = candidatesDatas?.find(
    (item) => item.profileId === profileId
  );

  const handleClearFilterChange = () => {
    setLocation("");
    setTechnologies("");
    setMobile("");
    setSourcedBy("");
    setEmail("");
    setProfileId("");
    setFromDate(null);
    setToDate(null);
  };
  const handleFilterDialogClose = () => {
    setFilterDialogOpen(false);
  };

  // dialog box properties...
  const [open, setOpen] = useState(false);
  const [openpostions, setoPenPostions] = useState(false);
  const handleClose = () => {
    setOpen(false);
    setHistorytableLoder(false);
    setCandiateHistory(false)
  };

  // for filter dialog box open
  const handleCloseFilterDialog = () => {
    setFilterDialogOpen(false);
    const hasValue = chips?.some((item) => item?.label);
    if (!hasValue) {
      setLocation("");
      setTechnologies("");
      setMobile("");
      setSourcedBy("");
      setEmail("");
      setProfileId("");
      setFromDate(null);
      setToDate(null);
      localStorage.setItem(
        "commonsearchfilter",
        JSON.stringify({ ...commonFilter, candidateProfiles: {} })
      );
    }
  };
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);

  const onchangesearchbar = (event) => {
    localStorage.setItem("candidateProfileSearchValue", event.target.value);
    if (value === "0") {
      setPage(1);
      setSearch(event.target.value);
    } else if (value === "1") {
      localStorage.setItem("joinedCandidatesearch", event.target.value);
      setCandidateJoinedPage(1);
      setJoinedCandidateDataSearch(event.target.value);
    } else if (value === "2" || value === "3" || value === "4") {
      setSearch(event.target.value);
    }
    setTriggerApi(true);

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    // 2. Update the clientId inside dashbord
    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.firstNameOrLastName,
        firstNameOrLastName: value,
      },
    };

    // 3. Store the updated object back in localStorage
    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const handleOpenFillterDialog = () => {
    setFilterDialogOpen(true);
  };

  const handleGetLocation = (e) => {
    setLocation(e.target.value);
    const value = e.target.value;

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.candidateProfiles,
        address: value,
      },
    };

    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const handleMobile = (e) => {
    setMobile(e.target.value);
    const value = e.target.value;

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.candidateProfiles,
        mobileOrAlternateMobile: value,
      },
    };

    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
    const value = e.target.value;

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.candidateProfiles,
        emailOrAlternateEmail: value,
      },
    };

    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const handleCheckboxChanges = (e) => {
    const value = e.target.value;
    setSelectedKeywordIds(value);

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.candidateProfiles,
        technologies: value,
      },
    };

    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const handleSourcedBy = (e) => {
    setSourcedBy(e.target.value);
    const value = e.target.value;

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.candidateProfiles,
        sourcedBy: value,
      },
    };

    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const hanldeFromDate = (value) => {
    if (toDate && toDate <= value) {
      setToDate(null);
    }
    setFromDate(value);

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.candidateProfiles,
        fromDate: value,
      },
    };

    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const handleTodate = (value) => {
    setToDate(value);

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.candidateProfiles,
        toDate: value,
      },
    };

    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const getNextDay = (fromDate) => {
    if (!fromDate) {
      return null;
    }
    return dayjs(fromDate)?.add(1, "day");
  };

  const handleSorting = (e) => {
    if (!arrow) {
      setSortingColumnDirection("ASC");
      setArrow(true);
      setTriggerApi(true);
    } else {
      setSortingColumnDirection("DESC");
      setArrow(false);
      setTriggerApi(true);
    }
  };

  const [searchQuery, setSearchQuery] = useState("");

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Filter positions based on the search query
  const filteredPositions = positions?.response?.filter(
    (position) =>
      position.listData.toLowerCase().includes(searchQuery.toLowerCase()) ||
      position.positionDesc.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleCheckboxChange = (event, positionId) => {
    const newSelectedIds = event.target.checked
      ? [...selectedPositionIds, positionId] // Add the id if checked
      : selectedPositionIds.filter((id) => id !== positionId); // Remove if unchecked
    setSelectedPositionIds(newSelectedIds);
  };

  const addJob = async () => {
    try {
      const payload = {
        clientName: "",
        positionTitle: "",
        candiateId: profileId,
      };

      const response = await addJobPostion(payload)?.unwrap();
      setPositions(response);
    } catch (error) {
      Snackbar("Network error", "error");
    }
  };

  const assignPositions = async () => {
    try {
      if (selectedPositionIds.length > 0) {
        const payload = {
          profileId: profileId,
          position: selectedPositionIds,
        };

        const response = await selectedJobPosition(payload).unwrap();
        Snackbar(response?.response?.message, "success");
        handleClosePosition();
        setSelectedPositionIds([]);
        setSearchQuery("");
      }
    } catch (error) {
      Snackbar("Network error", "error");
    }
  };

  const getTableDatas = async () => {
    try {
      const params = {
        // sortingColumn: "",
        sortingDirection: sortingColumnDirection || "",
        address: location,
        technologies: selectedKeywordIds.join(","),
        mobileOrAlternateMobile: mobile,
        emailOrAlternateEmail: email,
        sourceBy: sourcedBy,
        namePhoneEmailSearch: search,
        fromDate: fromDate ? dayjs(fromDate)?.format("YYYY-MM-DD") : "",
        toDate: toDate ? dayjs(toDate)?.format("YYYY-MM-DD") : "",
        page: page - 1 || 0,
        size: rowsPerPage ? rowsPerPage : 10,
      };
      if (userRole === "recruiter" && isExternal === "Y") {
        setShowTableLoader(true);
        const response = await TableDatasForClient(params).unwrap();
        setShowTableLoader(false);
        setCandidatesDatas(response.response?.data);
        setCount(response?.response?.Count);
      } else if (userRole === "recruiter" && isExternal === "N") {
        setShowTableLoader(true);
        const response = await viewInternalReferralCandidate(params).unwrap();
        setShowTableLoader(false);
        setCandidatesDatas(response.response?.data);
        setCount(response?.response?.Count);
      } else {
        setShowTableLoader(true);
        const response = await TableDatas(params).unwrap();
        setShowTableLoader(false);
        setCandidatesDatas(response.response?.data);
        setCount(response?.response?.Count);
      }
    } catch (err) {
      Snackbar("Network failed", "error");
      setShowTableLoader(false);
    }
  };

  const joinedDatas = async () => {
    setShowTableLoader(true);
    try {
      const payload = {
        page: candidateJoinedPage ? candidateJoinedPage - 1 : 0,
        size: joinedRowsPerPage ? joinedRowsPerPage : 10,
        candidateSearch: joinedCandidateDataSearch ? joinedCandidateDataSearch : "" || "",
        sourceBy: sourcedBy,
        fromDate: fromDate ? dayjs(fromDate)?.format("YYYY-MM-DD") : null,
        toDate: toDate ? dayjs(toDate)?.format("YYYY-MM-DD") : null,
      };
      const response = await joinedCandidate(payload).unwrap();
      setShowTableLoader(false);
      setJoinedCandidateDatas(response.response?.data);
      setCounts(response?.response?.totalItems);
    } catch (err) {
      Snackbar("Network failed", "error");
      setShowTableLoader(false);
    }
  };
  const [chips, setChips] = useState([]);

  const letsFilterDatas = () => {
    const updateChip = [
      {
        label: location,
        onDelete: () => {
          setLocation("");
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              candidateProfiles: {
                ...commonFilter.candidateProfiles,
                address: "",
              },
            })
          );
          setTriggerApi(true);
          setChips((prevChips) =>
            prevChips?.filter((chips) => chips?.label !== location)
          );
        },
      },
      {
        label: mobile,
        onDelete: () => {
          setMobile("");
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              candidateProfiles: {
                ...commonFilter.candidateProfiles,
                mobileOrAlternateMobile: "",
              },
            })
          );
          setTriggerApi(true);
          setChips((prevChips) =>
            prevChips?.filter((chips) => chips?.label !== mobile)
          );
        },
      },
      {
        label: email,
        onDelete: () => {
          setEmail("");
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              candidateProfiles: {
                ...commonFilter.candidateProfiles,
                emailOrAlternateEmail: "",
              },
            })
          );
          setTriggerApi(true);
          setChips((prevChips) =>
            prevChips?.filter((chips) => chips?.label !== email)
          );
        },
      },
      ...selectedKeywords?.map((item) => ({
        label: item?.keywordName,
        onDelete: () => {
          setSelectedKeywordIds((prevIds) =>
            prevIds.filter((id) => id !== item?.KeywordId)
          );
          setTriggerApi(true);
          setChips((prevChips) =>
            prevChips?.filter((chip) => chip?.label !== item?.keywordName)
          );
        },
      })),
      fromDate && {
        label: fromDate ? dayjs(fromDate)?.format("DD-MM-YYYY") : "",
        onDelete: () => {
          setFromDate(null);
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              candidateProfiles: {
                ...commonFilter.candidateProfiles,
                fromDate: null,
              },
            })
          );
          setTriggerApi(true);
          setToDate(null);
          setChips((prevChips) =>
            prevChips?.filter(
              (chips) => chips?.label !== dayjs(fromDate)?.format("DD-MM-YYYY")
            )
          );
        },
      },
      toDate && {
        label: toDate ? dayjs(toDate)?.format("DD-MM-YYYY") : "",
        onDelete: () => {
          setToDate(null);
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              candidateProfiles: {
                ...commonFilter.candidateProfiles,
                toDate: null,
              },
            })
          );
          setTriggerApi(true);
          setChips((prevChips) =>
            prevChips?.filter(
              (chips) => chips?.label !== dayjs(toDate)?.format("DD-MM-YYYY")
            )
          );
        },
      },
      {
        label: sourcedBy,
        onDelete: () => {
          setSourcedBy("");
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              candidateProfiles: {
                ...commonFilter.candidateProfiles,
                sourcedBy: "",
              },
            })
          );
          setTriggerApi(true);
          setChips((prevChips) =>
            prevChips?.filter((chips) => chips?.label !== sourcedBy)
          );
        },
      },
    ].filter(Boolean);

    setChips(updateChip);
    setTriggerApi(true);
    setShowClearFilter(true);
  };


  useEffect(() => {
    const candidateProfiles = commonFilter?.candidateProfiles;
    const hasValue =
      candidateProfiles &&
      Object.values(candidateProfiles)?.some(
        (value) =>
          value !== 0 && value !== null && value !== undefined && value !== ""
      );

    if (hasValue) {
      setShouldFetch(true);
    }
  }, []);

  const [value, setValues] = useState(() => {
    return localStorage.getItem("candidateValue") || "0";
  });

  const handleChange = (event, newValue) => {
    localStorage.removeItem("joinedCandidatesearch");
    localStorage.setItem("candidateValue", newValue);
    setSelectedKeywordIds([] || "");
    setChips(null);
    localStorage.removeItem("commonsearchfilter");
    setValues(newValue);
    // Clear search when switching tabs
    setSearch("");
    setJoinedCandidateDataSearch("");
    localStorage.removeItem("candidateProfileSearchValue");
    handleClearFilterChange();
  };

  const renderTabContent = () => {
    switch (value) {
      case "2":
        return <OfferedCandidate search={search} />;
      case "3":
        return <SelectedCandidate search={search} />;
      case "4":
        return <AllCandidates search={search} />;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (value === "0") {
      getTableDatas();
    } else {
      joinedDatas();
    }
  }, [value, candidateJoinedPage, openpostions]);

  useEffect(() => {
    getEventProfiles();
  }, []);

  useEffect(() => {
    getEventProfiles();
    setDropdownEvent(eventDropDown?.response);
    setEventOptions(eventDropDown?.response);
  }, [eventDropDown, dropdownEvent, mainEvent]);

  const getEventProfiles = async () => {
    const eventId = +mainEvent;
    if (!eventId) {
      try {
        const payload = {
          eventTypeId: 0,
          profileId: profileId ? profileId : 0,
          page: page ? page - 1 : 0,
          size: 10000,
        };
        setShowTableLoader(true);
        const response = await profileEventsApi(payload).unwrap();
        setShowTableLoader(false);
        setProfileEvents(response?.response?.profileEvents || []);
        setTotalPageCount(response?.response?.count);
      } catch (error) {
        Snackbar("Network error", "error");
      }
    } else {
      try {
        const payload = {
          eventTypeId: eventId,
          page: page ? page - 1 : 0,
          profileId: profileId,
          size: rowsPerPage ? rowsPerPage : 100,
        };
        const response = await profileEventsApi(payload).unwrap();
        setProfileEvents(response?.response?.profileEvents);
        setTotalPageCount(response?.response?.count);
      } catch (error) {
        Snackbar("Network error", "error");
      }
    }
  };

  useEffect(() => {
    if (triggerApi) {
      getTableDatas();
      handleCloseFilterDialog();
      setTriggerApi(false);
    }
    if (triggerApi && value === "0") {
      getTableDatas();
      handleFilterDialogClose();
      setTriggerApi(false);
    } else if (triggerApi && value === "1") {
      joinedDatas();
      handleFilterDialogClose();
      setTriggerApi(false);
    }
  }, [
    TableDatas,
    rowsPerPage,
    joinedRowsPerPage,
    page,
    search,
    sortingColumnDirection,
    triggerApi,
  ]);

  // Navigations
  const manage_Events = (row) => {
    navigate(`/manage-events-candidate/${row?.profileId}`, {
      state: {
        profileId: row?.profileId,
        firstName: row.firstName,
        lastName: row.lastName,
        email: row.email,
        mobile: row.mobile,
        remarks: row.remarks,
      },
    });
  };

  const handleCandidateNav = (row) => {
    navigate(`/candidate-view/${row?.profileId}`, {
      state: {
        profileAssignedJob: row?.profileAssignedJob,
      },
    });
    // navigate(`/editcandidateprofile/${row.profileId}`)
  };

  const handleAddCandidateNav = () => {
    navigate("/addcandidateprofile");
  };

  const handleChangePage = (event, newPage) => {
    localStorage.setItem("candidateProfileNewPage", newPage);
    setPage(newPage);
    setTriggerApi(true);
  };

  const handleChangeJoinedPage = (event, newPage) => {
    localStorage.setItem("candidateProfileJoinedPage", newPage);
    setCandidateJoinedPage(newPage);
    // setTriggerApi(true)
  };
  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  const viewHistory = async (profileId) => {
    setOpen(true);
    try {
      const payload = {
        profileId: profileId,
        positionId: 0,
        page: page - 1,
        size: 5000,
      };
      const response = await viewcandidateHistory(payload)?.unwrap();
      if (response) {
        setCandiateHistory(response?.response?.eventHistory);
        setHistorytableLoder(true);
      }
    } catch (error) {
      Snackbar("Network error", "error");
    }
  };

  const addPosition = (profileId) => {
    setoPenPostions(true);
    setProfileId(profileId);
  };

  const handlePositionId = (positionId) => {
    setSelectedPositionIds((prevSelected) =>
      prevSelected?.includes(positionId)
        ? prevSelected?.filter((id) => id !== positionId)
        : [...prevSelected, positionId]
    );
  };

  useEffect(() => {
    const positionNames = positions?.response?.filter((item) =>
      selectedPositionIds?.includes(item?.positionId)
    );
    setPositionNames(positionNames);
  }, [selectedPositionIds, positions]);

  const handleClosePosition = () => {
    setoPenPostions(false);
  };

  const [MinihistoryDialogOpen, setMinihistoryDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState([]);
  const [profileMatchId, setProfileMatchId] = useState();
  const [isDelete, setIsDelete] = useState(false);

  const handleCloseDelete = () => {
    setMinihistoryDialogOpen(false);
  };

  const hanldeMiniDialogOpen = (item) => {
    setMinihistoryDialogOpen(true);
    setProfileMatchId(item?.profileMatchId);
    setDeleteId(item?.eventHistoryId);
    setIsDelete(item?.deletable);
  };

  const deleteEventHistory = async (item) => {
    if (isDelete === true) {
      try {
        const payload = {
          eventHistoryIds: [deleteId] || [],
          profileMatchId: profileMatchId, // Use 0 as default if profileMatchId is missing
        };

        const response = await deleteHistory(payload).unwrap();
        setMinihistoryDialogOpen(false);
        setOpen(false);

        Snackbar(response?.response?.message, "success");
      } catch (error) {
        Snackbar("Network error", "error");
      }
    } else {
      Snackbar("Network error", "error");
    }
  };

  const formatDate = (date = new Date()) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleclearFilterState = () => {
    setTechnologies("");
    setMobile("");
    setLocation("");
    setEmail("");
    setFromDate(null);
    setToDate(null);
    setSourcedBy("");
    setTriggerApi(true);
    setShowClearFilter(false);
    localStorage.setItem(
      "commonsearchfilter",
      JSON.stringify({ ...commonFilter, candidateProfiles: {} })
    );
  };

  useEffect(() => {
    if (positions?.response) {
      const selectedJObId = positions.response.filter((id) => id?.hasSelected);
      const ids = selectedJObId?.map((id) => id?.positionId);
      setSelectedPositionIds(ids);
    }
  }, [positions]);

  useEffect(() => {
    if (chips?.every((name) => !name?.label)) {
      setShowClearFilter(false);
    }
  }, [triggerApi]);

  useEffect(() => {
    if (profileId) {
      addJob();
    }
  }, [openpostions]);

  useEffect(() => {
    if (shouldFetch) {
      letsFilterDatas();
      setShouldFetch(false);
    }
  }, [page, shouldFetch]);

  const handleDownload = (cvPath) => {
    const profilePath = cvPath;

    if (profilePath !== null) {
      const extension = profilePath
        .substring(profilePath?.lastIndexOf(".") + 1)
        .toLowerCase();
      const name = profilePath.substring(profilePath?.lastIndexOf("/") + 1);
      if (extension === "docx" || extension === "doc") {
        const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${profilePath}`;
        const link = document.createElement("a");
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        Snackbar("File Downloaded", "success");
      } else if (extension === "pdf") {
        const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${profilePath}`;
        window.open(url, "_blank");
        // Snackbar("File Downloaded", "success")
      } else {
        Snackbar("Unable to download Profile", "error");
      }
    }
  };

  const [openPaymentDialog, setOpenPaymentDialog] = useState(false);
  const [candidateCommissionAmount, setCandidateCommissionAmount] =
    useState("");
  const [jobCommissionAmount, setJobCommissionAmount] = useState("");
  const [clientCommissionAmount, setClientCommissionAmount] = useState("");
  const [
    candidateCommissionAmountEarnedBy,
    setCandidateCommissionAmountEarnedBy,
  ] = useState("");
  const [jobCommissionAmountEarnedBy, setJobCommissionAmountEarnedBy] =
    useState("");
  const [message, setMessage] = useState("");
  const [clientCommissionAmountEarnedBy, setClientCommissionAmountEarnedBy] =
    useState("");
  const [candidateSalary, setCandidateSalary] = useState("");
  const [billingAmount, setBillingAmount] = useState("")
  const [candidateName, setCandidateName] = useState("");
  const [clientRewardPercentage, setClientRewardPercentage] = useState("10%");
  const [positionRewardPercentage, setPositionRewardPercentage] =
    useState("10%");
  const [candidateRewardPercentage, setCandidateRewardPercentage] =
    useState("10%");
  const [clientRewardType, setClientRewardType] = useState("");
  const [positionRewardType, setPositionRewardType] = useState("");
  const [candidateRewardType, setCandidateRewardType] = useState("");
  const [openCommissionDialog, setOpenCommissionDialog] = useState(false);

  const [profileName, setProfileName] = useState("");
  const [positionName, setPositionName] = useState("");
  const [clientName, setClientName] = useState("")
  const [positionId, setPositionId] = useState("");
  const [clientId, setClientId] = useState("");
  const [positionType, setPositionType] = useState("")
  const [commissionAmt, setCompanyCommissiionAmt] = useState()
  const [finalJoiningDate, setFinalJoiningDate] = useState(null);
  console.log("finalJoiningDate", finalJoiningDate);


  const handleOpenPaymentDialog = (row) => {
    // if (row?.positionType === "Contract") {
    //   setOpenContractDialog(true)
    // } else {
    //   setOpenPaymentDialog(true)
    // }
    setOpenContractDialog(true)
    setProfileName(row?.profileName);
    setClientName(row?.clientName)
    setPositionName(row?.positionName);
    setPositionId(row?.positionId);
    setProfileId(row?.profileId);
    setClientId(row?.clientId);
    setValue("companyCommissionType", row?.companyCommissionType === null ? "" : row?.companyCommissionType === "FP" ? 2 : 1)
    setValue("companyCommissionPercentage", row?.companyCommissionPercentage || "")
    setValue("companyCommissionAmount", row?.companyCommissionAmount || "")
    setValue("commissionMode", "OTS")
    setCompanyCommissiionAmt(row?.companyCommissionAmount)
    setFinalJoiningDate(row?.finalJoiningDate)
    // setPositionType(row?.positionType)
    // if (row?.positionType === "Permanent") {
    //   setValue("commissionMode", "OTS")
    // } else {
    //   setValue("commissionMode", "RCP")
    // }

  };

  const handleCloseCommissionDialog = () => {
    setOpenCommissionDialog(false);
    setTriggerApi(true);
  };

  const handleClosePaymentDialog = () => {
    setOpen(false);
    setOpenPaymentDialog(false);
    reset();
  };

  const onSubmit = async (data) => {
    try {
      const payload = {
        profileID: profileId,
        positionId: positionId,
        candidateJoiningDate: data?.joiningDate
          ? dayjs(data?.joiningDate)?.format("YYYY-MM-DD")
          : "",
        candidateAnnualSalary: +data?.annualSalary,
        clientId: clientId,
      };
      const response = await makeReferralCommission(payload).unwrap();
      if (response) {
        // Snackbar(response?.response?.message, 'success')
        setOpenCommissionDialog(true);
        setCandidateCommissionAmountEarnedBy(
          response?.response?.candidateCommissionAmountEarnedBy
        );
        setCandidateCommissionAmount(
          response?.response?.candidateCommissionAmount
        );
        setJobCommissionAmount(response?.response?.jobCommissionAmount);
        setJobCommissionAmountEarnedBy(
          response?.response?.jobCommissionAmountEarnedBy
        );
        setMessage(response?.response?.message);
        setClientCommissionAmount(response?.response?.clientCommissionAmount);
        setClientCommissionAmountEarnedBy(
          response?.response?.clientCommissionAmountEarnedBy
        );
        setCandidateSalary(response?.response?.candidateAnnualSalary);
        setCandidateName(response?.response?.candidateFullName);
        setClientRewardPercentage(
          response?.response?.clientRewardType === "FP"
            ? response?.response?.clientRewardPercentage
            : response?.response?.clientCommissionAmount
        );
        setPositionRewardPercentage(
          response?.response?.positionRewardType === "FP"
            ? response?.response?.positionRewardPercentage
            : response?.response?.jobCommissionAmount
        );
        setCandidateRewardPercentage(
          response?.response?.candidateRewardType === "FP"
            ? response?.response?.candidateRewardPercentage
            : response?.response?.candidateCommissionAmount
        );
        setPositionRewardType(response?.response?.positionRewardType);
        setCandidateRewardType(response?.response?.candidateRewardType);
        setClientRewardType(response?.response?.clientRewardType);
        setOpenPaymentDialog(false);
        setTriggerApi(false);
        reset();
        setValue("annualSalary", "");
        setValue("joiningDate");
      }
    } catch (error) {
      Snackbar("Network error", "error");
    }
  };

  const steps = [
    { label: "Enter Details", icon: <Person /> },
    // { label: "Verification", icon: <Calculate /> },
    { label: "Commission", icon: <Payment /> }
  ];

  const [activeStep, setActiveStep] = useState(0);

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const handleCloseContract = () => {
    setOpenContractDialog(false);
    reset()
    setValue("billingRate", "")
    setValue("candidateAnnualSalary", "")
    // setValue("commissionMode", "")
    setValue("companyCommissionAmount", "")
    setValue("companyCommissionPercentage", "")
    // setValue("companyCommissionType", "")
    setValue("contractCandidateJoiningDate", null)
    setValue("contractCloseDate", null)
    setValue("contractOpenDate", null)
    setValue("periodOfTime", "")
    setValue("units", "")
    setActiveStep(0);
  }

  const handleCloseInstructionDialog = () => {
    setOpenContractDialog(false);
  }

  const units = [
    {
      id: 1,
      label: "INR",
    },
    {
      id: 2,
      label: "USD",
    },
    {
      id: 3,
      label: "CAD",
    },
    {
      id: 4,
      label: "AED",
    },
  ];

  const periodOfTime = [
    {
      id: "Y",
      label: "Per Year",
    },
    {
      id: "M",
      label: "Per Month",
    },
    {
      id: "D",
      label: "Per Day",
    },
    {
      id: "H",
      label: "Per Hour",
    },
  ];

  const commissionMode = [
    {
      id: 'OTS',
      label: 'One Time Settlement'
    },
    // {
    //   id: 'RCP',
    //   label: 'Recurring'
    // },

  ]

  const modeOfCommission = watch("commissionMode")


  const billingRate = watch("billingRate")
  const unit = watch("periodOfTime")
  const cycle = watch("units")
  const contractCandidateJoiningDate = watch("contractCandidateJoiningDate")
  const contractOpenDate = watch("contractOpenDate")
  const contractCloseDate = watch("contractCloseDate")

  useEffect(() => {
    if (contractCloseDate < contractOpenDate) {
      setValue("contractCloseDate", null)
    }
  }, [contractOpenDate])

  const handleSaveCommission = async (data) => {
    try {
      const payload = {
        profileID: profileId,
        positionId: positionId,
        candidateJoiningDate: data?.contractCandidateJoiningDate ? dayjs(data?.contractCandidateJoiningDate)?.format("YYYY-MM-DD") : null,
        status: "Pending",
        candidateSalary: data?.billingRate ? data?.billingRate : data?.candidateAnnualSalary || null,
        currencyUnit: data?.periodOfTime || null,
        billingCurrency: data?.units || null,
        contractStartDate: data?.contractOpenDate ? dayjs(data?.contractOpenDate)?.format("YYYY-MM-DD") : null,
        contractEndDate: data?.contractCloseDate ? dayjs(data?.contractCloseDate)?.format("YYYY-MM-DD") : null,
        candidateCommissionMode: data?.commissionMode,
        companyCommissionType: isAmount ? "FC" : "FP",
        companyCommissionPercentage: data?.companyCommissionPercentage,
        companyCommissionAmount: +data?.companyCommissionAmount,
        reasonForCancellation: null,
      }

      const response = await makeCommission(payload).unwrap()
      if (response) {
        // Snackbar(response?.response?.message, 'success')
        // setOpenCommissionDialog(true);
        setCandidateCommissionAmountEarnedBy(
          response?.response?.candidateCommissionAmountEarnedBy
        );
        setCandidateCommissionAmount(
          response?.response?.candidateCommissionAmount
        );
        setJobCommissionAmount(response?.response?.jobCommissionAmount);
        setJobCommissionAmountEarnedBy(
          response?.response?.jobCommissionAmountEarnedBy
        );
        setMessage(response?.response?.message);
        setClientCommissionAmount(response?.response?.clientCommissionAmount);
        setClientCommissionAmountEarnedBy(
          response?.response?.clientCommissionAmountEarnedBy
        );
        setBillingAmount(response?.response?.billingAmount);
        setCandidateName(response?.response?.candidateFullName);
        setClientRewardPercentage(
          response?.response?.clientRewardType === "FP"
            ? response?.response?.clientRewardPercentage
            : response?.response?.clientCommissionAmount
        );
        setPositionRewardPercentage(
          response?.response?.positionRewardType === "FP"
            ? response?.response?.positionRewardPercentage
            : response?.response?.jobCommissionAmount
        );
        setCandidateRewardPercentage(
          response?.response?.candidateRewardType === "FP"
            ? response?.response?.candidateRewardPercentage
            : response?.response?.candidateCommissionAmount
        );
        setPositionRewardType(response?.response?.positionRewardType);
        setCandidateRewardType(response?.response?.candidateRewardType);
        setClientRewardType(response?.response?.clientRewardType);
        setOpenContractDialog(false);
        Snackbar(response?.response?.message, 'success')
        handleCloseContract()
        setTriggerApi(false);
        joinedDatas()
      }

    } catch (err) {
      Snackbar("Network error", 'error')
    }
  };

  const currencySymbol = cycle === 'THI' ? 'د.إ' :
    cycle === 'INR' ? '₹' :
      cycle === 'USD' ? '$' : 'C$'

  const rewardTypes = [
    {
      id: 1,
      label: "Fixed Amount",
    },
    {
      id: 2,
      label: "Fixed Percentage",
    },
  ];


  const commissionType = watch("companyCommissionType")

  useEffect(() => {
    if (commissionType !== 1) {
      setIsAmount(false)
    } else {
      setIsAmount(true)
    }
  }, [commissionType])

  const handleNavToAddCommission = () => {
    navigate('/client-view', {
      state: {
        tabValue: "3", clientId: clientId, clientName: clientName
      }
    })
  }

  const [eventHistory] = useEventsHistoryMutation();
  const [historyTableDatas, setHistoryTableDatas] = useState([]);
  const [openCandidateHistory, setCandidatHistory] = useState(false)

  const handleOpenCandidateHistory = (row) => {
    setCandiateHistory(true)
    setProfileId(row?.profileid)
    setPositionId(row?.positionId)
  }

  useEffect(() => {
    const getHistoryTableDatas = async () => {
      try {
        const payload = {
          page: 0,
          positionId: positionId,
          profileId: profileId,
          size: 5000,
        };
        if (openCandidateHistory) {
          const response = await eventHistory(payload).unwrap();
          if (response?.status === 200) {
            setHistoryTableDatas(response?.response?.eventHistory);
            setProfileId('')
            setPositionId('')
          }
        }
      } catch (err) {
        Snackbar("Network error", "error");
      }
    };
    getHistoryTableDatas();
  }, [openCandidateHistory]);

  return (
    <Box className="container">
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
          flexWrap: "wrap",
        }}
      >
        <Box>
          <Typography className="title">
            {userRole === "recruiter" ? "Refer a Candidate" : "Candidates"}{" "}
          </Typography>
        </Box>

        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{ display: "flex", flexDirection: "row", gap: "20px" }}
        >
          {/* {
            value === "0" && ( */}
          <TextField
            placeholder="Search by name,mobile,email"
            className="textfields1"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start" sx={{ marginRight: "5px" }}>
                    <SearchIconLg width={20} height={20} />
                  </InputAdornment>
                ),
              },
            }}
            value={
              value === "0" || value === "2" || value === "3" || value === "4"
                ? search
                : joinedCandidateDataSearch
            }
            onChange={onchangesearchbar}
          />

          {/* )
          } */}
          {value === "0" && (
            <MUICancelButton
              title={
                userRole === "recruiter"
                  ? "Refer a Candidate"
                  : "Add Candidates"
              }
              sx={{
                border: "1px solid #7F56D9",
                color: "#ffffff",
                backgroundColor: "#7F56D9",
                width: "150px",
              }}
              startIcon={<AddIcon />}
              onClick={handleAddCandidateNav}
            ></MUICancelButton>
          )}
        </Box>
      </Box>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            aria-label="Overview and Candidates tabs"
            textColor="primary"
            indicatorColor="secondary"
          >
            <Tab
              label="All Candidates"
              value="4"
              className="tabs"
              sx={{
                textTransform: "none",
                fontWeight: value === "4" ? "bold" : "normal",
                transition: "all 0.3s ease",
              }}
            />
            <Tab
              label="Available Candidates"
              value="0"
              className="tabs"
              sx={{
                textTransform: "none",
                fontWeight: value === "0" ? "bold" : "normal",
                transition: "all 0.3s ease",
              }}
            />
            <Tab
              label="Joined Candidates"
              value="1"
              className="tabs"
              sx={{
                textTransform: "none",
                fontWeight: value === "1" ? "bold" : "normal",
                transition: "all 0.3s ease",
              }}
            />
            <Tab
              label="Offered Candidates"
              value="2"
              className="tabs"
              sx={{
                textTransform: "none",
                fontWeight: value === "2" ? "bold" : "normal",
                transition: "all 0.3s ease",
              }}
            />
            <Tab
              label="Selected (Client)"
              value="3"
              className="tabs"
              sx={{
                textTransform: "none",
                fontWeight: value === "3" ? "bold" : "normal",
                transition: "all 0.3s ease",
              }}
            />
          </TabList>
        </Box>
        <TabPanel value="0" sx={{ display: "flex", padding: "0px" }}>
          <Paper
            sx={{
              width: "100%",
              overflow: "auto",
              marginTop: "10px",
              border: "1px solid #E9EAEB",
              borderRadius: "10px",
            }}
            elevation={0}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={100} sx={{ padding: "5px" }}>
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <div>
                        {showClearFilter &&
                          chips?.map(
                            (chip, index) =>
                              chip?.label && (
                                <Chip
                                  variant="outlined"
                                  size="small"
                                  className="Chip"
                                  key={index}
                                  label={chip?.label}
                                  deleteIcon={
                                    <CloseIcon
                                      sx={{ color: "#414651 !important" }}
                                    />
                                  }
                                  onDelete={chip?.onDelete}
                                />
                              )
                          )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "14px",
                        }}
                      >
                        <MUICancelButton
                          title="More Filters"
                          onClick={handleOpenFillterDialog}
                          startIcon={
                            <FilterListOutlinedIcon
                              sx={{ fontSize: "14px !important" }}
                            />
                          }
                          sx={{
                            color: "#6941C6",
                            borderColor: "#D6BBFB",
                            fontWeight: 600,
                            width: "130px",
                          }}
                        />
                        {(location ||
                          technologies ||
                          mobile ||
                          email ||
                          fromDate ||
                          toDate ||
                          sourcedBy) &&
                          showClearFilter && (
                            <MUICancelButton
                              title="Clear filter"
                              onClick={handleclearFilterState}
                              sx={{ width: "100px" }}
                            />
                          )}
                      </div>
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  {/* <TableCell className='tableHeadersCell_2' >Id</TableCell> */}
                  <TableCell
                    className="tableHeadersCell_2"
                    onClick={handleSorting}
                  >
                    <Typography
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        fontSize: "12px",
                        cursor: "pointer",
                        fontFamily: "sans-serif",
                        fontWeight: 550,
                      }}
                    >
                      Name
                      {arrow ? (
                        <ArrowDownwardSharpIcon sx={{ fontSize: "18px" }} />
                      ) : (
                        <ArrowUpwardSharpIcon sx={{ fontSize: "16px" }} />
                      )}
                    </Typography>
                  </TableCell>
                  <TableCell className="tableHeadersCell_2">Location</TableCell>
                  {/* <TableCell className='tableHeadersCell_2'>Technologies</TableCell> */}
                  <TableCell className="tableHeadersCell_2">
                    Phone / Alternate Phn{" "}
                  </TableCell>
                  <TableCell className="tableHeadersCell_2">
                    Email / Alternate Email{" "}
                  </TableCell>
                  <TableCell className="tableHeadersCell_2">
                    Sourced By
                  </TableCell>
                  {/* <TableCell className='tableHeadersCell_2'>Is Referral</TableCell> */}
                  <TableCell className="tableHeadersCell_2" align="center">
                    Created Date
                  </TableCell>
                  {/* <TableCell className='tableHeadersCell_2' align='left'>Status</TableCell> */}
                  {userRole === "recruiter" ? (
                    ""
                  ) : (
                    <TableCell
                      className="tableHeadersCell_2"
                      align="center"
                      sx={{ width: "100px" }}
                    >
                      Action
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              {!showTableLoader ? (
                candidatesDatas?.length > 0 ? (
                  <TableBody>
                    {candidatesDatas?.map((row, index) => {
                      const colors = [
                        "green",
                        "darkorange",
                        "purple",
                        "#3357FF",
                        "orangered",
                        "darkgreen",
                        "pink",
                      ];
                      const backgroundColor = colors[index % colors?.length];
                      const techNames = row?.technologies?.map((item) => {
                        return item.itemName?.trim();
                      });
                      const twoTechs = techNames?.slice(0, 2);
                      const aboveTwoTechs = techNames?.slice(2);
                      return (
                        <TableRow
                          hover
                          tabIndex={-1}
                          key={row.code}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#FAFAFA" : "inherit",
                            "&:hover": { backgroundColor: "#f1f1f1" },
                          }}
                        >
                          {/* <TableCell onClick={() => handleCandidateNav(row)} className="tableBodyCell" sx={{ color: '#53389E', fontWeight: 'bold', fontSize: '14px', cursor: 'pointer' }} align='left'>{row.profileId}</TableCell> */}
                          <TableCell
                            className="tableBodyCells"
                            onClick={() => handleCandidateNav(row)}
                            sx={{ cursor: "pointer", position: "relative" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "10px",
                                alignItems: "center",
                              }}
                            >
                              <Typography className="tableBodyCells" noWrap>
                                <span
                                  style={{
                                    color: "#53389E",
                                    fontWeight: 600,
                                    fontSize: "12px",
                                    position: "relative",
                                    display: "inline-block",
                                    marginTop: "10px",
                                  }}
                                >
                                  {row?.firstName}{" "}
                                  <span>
                                    {row?.lastName}
                                    {row?.profileAssignedJob === "No" && (
                                      <span
                                        style={{
                                          backgroundColor: "#53389E",
                                          color: "white",
                                          fontSize: "10px",
                                          fontWeight: 600,
                                          padding: "1px 6px",
                                          borderRadius: "16px",
                                          position: "relative",
                                          bottom: "10px",
                                          left: "5px",
                                          fontSize: "10px",
                                          width: "auto",
                                          borderColor: "black",
                                        }}
                                      >
                                        <span
                                          style={{
                                            height: "6px",
                                            width: "6px",
                                            backgroundColor: "white", // or any color you prefer
                                            borderRadius: "50%",
                                            display: "inline-block",
                                            marginRight: "5px",
                                          }}
                                        ></span>
                                        New
                                      </span>
                                    )}
                                  </span>
                                </span>
                                <br />
                                <span>
                                  {row.referralPosition === "" ? (
                                    ""
                                  ) : (
                                    <>{row.referralPosition}</>
                                  )}
                                </span>
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell
                            className="tableBodyCells"
                            sx={{ color: "#181D27" }}
                          >
                            {row.address}
                          </TableCell>
                          {/* <TableCell className='tableBodyCells' sx={{ color: "#181D27" }}>
                        <Tooltip
                          slotProps={{
                            tooltip: {
                              sx: {
                                backgroundColor: "#0A0D12",
                                borderRadius: '8px',
                                padding: '8px 12px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                              }
                            }
                          }}
                          title={aboveTwoTechs?.join(', ')} arrow placement='top'>
                          {aboveTwoTechs?.length > 0 ? `${twoTechs?.join(', ')} and ${aboveTwoTechs?.length} more` : twoTechs?.join(', ')}
                        </Tooltip>
                      </TableCell> */}
                          <TableCell
                            className="tableBodyCells"
                            sx={{ color: "#181D27" }}
                          >
                            {" "}
                            {row.mobile}/<br />
                            {row.alternateMobile || "NA"}
                          </TableCell>
                          <TableCell
                            className="tableBodyCells"
                            sx={{ color: "#181D27" }}
                          >
                            {" "}
                            {row.email}/<br />
                            {row.alternateEmail || "NA"}
                          </TableCell>
                          <TableCell className="tableBodyCells">
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "5px",
                                alignItems: "center",
                              }}
                            >
                              <Avatar
                                alt={row?.firstName || "NA"}
                                sx={{
                                  width: "32px",
                                  height: "32px",
                                  backgroundColor: backgroundColor,
                                  fontSize: "14px",
                                }}
                              >
                                {row?.sourceName?.charAt(0)?.toUpperCase() ||
                                  "?"}
                              </Avatar>
                              <Typography
                                className="tableBodyCells"
                                sx={{ color: "#181D27" }}
                              >
                                {row?.sourceName}
                                {row?.isReferral !== "N" && (
                                  <span
                                    style={{
                                      color: "#5417cd",
                                      fontWeight: 600,
                                      marginLeft: "4px",
                                    }}
                                  >
                                    (BA)
                                  </span>
                                )}
                                <br></br>
                                <span style={{ color: "#535862" }}>
                                  {row?.sourceBy}
                                </span>
                              </Typography>
                            </Box>
                          </TableCell>
                          {/* <TableCell className="tableBodyCell" sx={{ Color: '#181D27' }}>{row?.isReferral === "N" ? 'No' : 'Yes'}</TableCell> */}
                          <TableCell
                            className="tableBodyCells"
                            sx={{ color: "#535862" }}
                            align="center"
                          >
                            {" "}
                            {formatDate(row.createdDate)}
                          </TableCell>
                          {/* <TableCell className="tableBodyCells" >
                            <span className={`candidateStatus-badge ${row?.status?.toLowerCase()}`}>
                              {row.status === "Active"
                                ? "Approved"
                                : row.status === "Inactive"
                                  ? "Rejected"
                                  : row.status === "Pending"
                                    ? "Pending"
                                    : ""}
                            </span>
                          </TableCell> */}
                          {userRole === "recruiter" ? (
                            ""
                          ) : (
                            <TableCell
                              className="tableBodyCells"
                              sx={{ minWidth: "100px", whiteSpace: "nowrap" }}
                            >
                              <Tooltip
                                title="History"
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#0A0D12",
                                      borderRadius: "8px",
                                      padding: "8px 12px",
                                      boxShadow:
                                        "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                    },
                                  },
                                }}
                              >
                                <span>
                                  <LuHistory
                                    onClick={
                                      row?.status === "Active"
                                        ? () => viewHistory(row?.profileId)
                                        : null
                                    }
                                    style={{
                                      fontSize: "17px",
                                      margin: "5px",
                                      cursor:
                                        row?.status === "Active"
                                          ? "pointer"
                                          : "not-allowed",
                                      color: "#b6bbbb",
                                      transition:
                                        "transform 0.2s ease, color 0.2s ease",
                                    }}
                                    onMouseOver={(e) => {
                                      if (row?.status === "Active") {
                                        e.currentTarget.style.color = "#5417cd";
                                        e.currentTarget.style.transform =
                                          "scale(1.2)";
                                      }
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.color = "#b6bbbb";
                                      e.currentTarget.style.transform =
                                        "scale(1)";
                                    }}
                                  />
                                </span>
                              </Tooltip>
                              <Tooltip
                                title={
                                  row?.candidateStatus !== "ENO"
                                    ? "Add Job"
                                    : "Candidate status is Not Open"
                                }
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#0A0D12",
                                      borderRadius: "8px",
                                      padding: "8px 12px",
                                      boxShadow:
                                        "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                    },
                                  },
                                }}
                              >
                                <CreateNewFolderOutlinedIcon
                                  className="icons"
                                  onClick={
                                    row?.candidateStatus !== "ENO"
                                      ? () => addPosition(row.profileId)
                                      : null
                                  }
                                  sx={{
                                    fontSize: "17px",
                                    margin: "5px",
                                    cursor:
                                      row?.candidateStatus !== "ENO"
                                        ? "pointer"
                                        : "not-allowed",
                                    pointerEvents: row?.candidateStatus === "ENO" ? "not-allowed" : "auto",
                                    transition:
                                      "transform 0.2s ease, color 0.2s ease",
                                    "&:hover": {
                                      transform:
                                        row?.status === "Active"
                                          ? "scale(1.2)"
                                          : "none",
                                      color:
                                        row?.status === "Active"
                                          ? "#5417cd"
                                          : "inherit",
                                    },
                                  }}
                                />
                              </Tooltip>
                              <Tooltip
                                title={
                                  row?.status === "Active"
                                    ? "Manage Events"
                                    : "Sorry, this candidate has already been joined to another company, so you cannot manage events for them."
                                }
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#0A0D12",
                                      borderRadius: "8px",
                                      padding: "8px 12px",
                                      boxShadow:
                                        "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                    },
                                  },
                                }}
                              >
                                <DescriptionOutlinedIcon
                                  className="icons"
                                  onClick={
                                    row?.status === "Active"
                                      ? () => manage_Events(row)
                                      : null
                                  }
                                  sx={{
                                    fontSize: "17px",
                                    margin: "5px",
                                    cursor:
                                      row?.status === "Active"
                                        ? "pointer"
                                        : "not-allowed",
                                    transition:
                                      "transform 0.2s ease, color 0.2s ease",
                                    "&:hover": {
                                      transform:
                                        row?.status === "Active"
                                          ? "scale(1.2)"
                                          : "none",
                                      color:
                                        row?.status === "Active"
                                          ? "#5417cd"
                                          : "inherit",
                                    },
                                  }}
                                />
                              </Tooltip>
                              <Tooltip
                                title={
                                  row?.cvPath !== null
                                    ? "Profile Download"
                                    : "No profile uploaded for this candidate."
                                }
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#0A0D12",
                                      borderRadius: "8px",
                                      padding: "8px 12px",
                                      boxShadow:
                                        "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                    },
                                  },
                                }}
                              >
                                <span>
                                  <BsDownload
                                    onClick={
                                      row?.cvPath !== null
                                        ? () => handleDownload(row?.cvPath)
                                        : null
                                    }
                                    style={{
                                      fontSize: "17px",
                                      margin: "5px",
                                      cursor:
                                        row?.cvPath === null
                                          ? "not-allowed"
                                          : "pointer",
                                      color: "#b6bbbb",
                                      transition:
                                        row?.cvPath === null
                                          ? ""
                                          : "transform 0.2s ease, color 0.2s ease",
                                    }}
                                    onMouseOver={(e) => {
                                      e.currentTarget.style.color =
                                        row?.cvPath === null
                                          ? "black"
                                          : "#5417cd";
                                      e.currentTarget.style.transform =
                                        row?.cvPath === null
                                          ? ""
                                          : "scale(1.2)";
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.color = "#b6bbbb";
                                      e.currentTarget.style.transform =
                                        "scale(1)";
                                    }}
                                  />
                                </span>
                              </Tooltip>
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={10}>
                        <Typography className="emptydatas">
                          No Data Found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={13}>
                    <Box className="tableloader">
                      <TableLoader />
                    </Box>
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                {count <= rowsPerPage ? (
                  ""
                ) : (
                  <TableCell colSpan={100}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <MUICancelButton
                        title="Previous"
                        startIcon={
                          <ArrowBackIcon
                            sx={{ color: page === 1 ? "#a2a2a2" : "#414651" }}
                          />
                        }
                        disabled={page === 1}
                        onClick={() => handleChangePage(null, page - 1)}
                        sx={{ height: "36px" }}
                      />
                      <Pagination
                        page={page}
                        onChange={handleChangePage}
                        count={Math.ceil(count / rowsPerPage)}
                        siblingCount={3}
                        boundaryCount={3}
                        shape="rounded"
                        hidePrevButton
                        hideNextButton
                      />

                      <MUICancelButton
                        title="Next"
                        startIcon={
                          <ArrowForwardIcon
                            sx={{
                              color:
                                page === Math.ceil(count / rowsPerPage)
                                  ? "#a2a2a2"
                                  : "#414651",
                            }}
                          />
                        }
                        disabled={page === Math.ceil(count / rowsPerPage)}
                        onClick={() => handleChangePage(null, page + 1)}
                        sx={{ height: "36px" }}
                      />
                    </div>
                  </TableCell>
                )}
              </TableRow>
            </Table>
          </Paper>
        </TabPanel>
        {/* Tab Content Section */}
        <Box>{renderTabContent()}</Box>
        <Grid2>
          <Dialog
            open={viewDialog}
            onClose={handleCloseViewDialog}
            scroll="paper"
            maxWidth="md"
            sx={{
              "& .MuiDialog-paper": {
                height: "auto",
                width: "100vw",
                // overflow: 'hidden' // Prevent vertical scroll here
              },
            }}
          >
            <DialogTitle sx={{ borderBottom: "1px solid black" }} variant="h6">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                {selectedCandidate && (
                  <Typography
                    sx={{
                      fontweight: "bold",
                      fontSize: "14px",
                      display: "flex",
                      flexDirection: "row",
                      gap: "5px",
                    }}
                  >
                    <AccountCircleOutlinedIcon
                      sx={{
                        position: "relative",
                        top: "2px",
                        fontSize: "16px",
                      }}
                    />
                    {selectedCandidate.firstName} {selectedCandidate.lastName}
                  </Typography>
                )}
                <Typography
                  sx={{ color: "green", position: "relative", right: 50 }}
                  variant="h6"
                  fontWeight="bold"
                  gutterBottom
                >
                  Candidate Life Cycle
                </Typography>
                <CloseIcon
                  sx={{ cursor: "pointer" }}
                  onClick={handleCloseViewDialog}
                />
              </Box>
            </DialogTitle>

            {totalPagecount > 0 ? (
              <Box
                sx={{
                  // Adjust based on DialogTitle height
                  // overflow: 'hidden', // Prevent vertical scroll
                  display: "flex",
                  justifyContent: totalPagecount < 3 ? "center" : "start",
                  backgroundColor: "#ffffff",
                  px: 4,
                  py: 2,
                }}
              >
                <Box
                  sx={{
                    overflowX: "auto",
                    display: "flex",
                    gap: 1,
                    padding: 2,
                  }}
                >
                  {profileEvents?.map((data, index) => {
                    const randomColor = getRandomColor(); // Use the updated color function
                    return (
                      <Grid2
                        key={data?.positionId}
                        sx={{
                          minWidth: 250,
                          position: "relative",
                          flexShrink: 0,
                        }}
                      >
                        <Avatar
                          sx={{
                            bgcolor: randomColor, // Use the same color for Avatar
                            width: 46,
                            height: 46,
                            mb: 2,
                            mx: "auto",
                            zIndex: 100,
                          }}
                        >
                          <Typography>{index + 1}</Typography>
                        </Avatar>

                        {index < profileEvents.length - 1 && (
                          <Box
                            sx={{
                              position: "absolute",
                              top: "2%",
                              left: "64%",
                              right: "64%",
                              width: "70%",
                              height: "20px",
                              backgroundColor: "#B0B0B0",
                              zIndex: 0,
                            }}
                          />
                        )}

                        <Typography
                          sx={{
                            textAlign: "center",
                            mb: 2,
                            fontWeight: "bold",
                          }}
                          noWrap
                        >
                          {data?.jobPostingName}
                        </Typography>

                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Box
                            style={{
                              border: "1px solid white",
                              borderRadius: "10px",
                              padding: 10,
                              width: "200px",
                              backgroundColor: randomColor, // Use the same color for background box
                            }}
                          >
                            {dropdownEvent?.map((item) => (
                              <Box
                                key={item?.eventTypeId}
                                onClick={() => setEvents(item?.eventTypeId)}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    color: "white",
                                    textAlign: "center",
                                    // marginBottom: '10px',
                                    cursor: "pointer",
                                  }}
                                >
                                  {item?.event}
                                </Typography>
                                {data?.eventTypeId === item?.eventTypeId && (
                                  <DoneOutlineOutlinedIcon
                                    sx={{ color: "white", fontSize: "12px" }}
                                  />
                                )}
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      </Grid2>
                    );
                  })}
                </Box>
              </Box>
            ) : (
              <Typography
                sx={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 5,
                }}
              >
                <img
                  src={Nodata}
                  alt="No data Found"
                  style={{ width: "35%", height: "60%" }}
                ></img>
                <span style={{ color: "#a0a0a0" }}>No Data Found</span>
              </Typography>
            )}
          </Dialog>
        </Grid2>

        {/*tab 2*/}
        <TabPanel value="1" sx={{ padding: "0px" }}>
          <Paper
            sx={{
              width: "100%",
              overflow: "auto",
              marginTop: "10px",
              border: "1px solid #E9EAEB",
              borderRadius: "10px",
            }}
            elevation={0}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={100} sx={{ padding: '5px' }} >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div>
                        {showClearFilter && (
                          chips?.map((chip, index) => (
                            chip?.label && (
                              <Chip
                                variant="outlined"
                                size='small'
                                className='Chip'
                                key={index}
                                label={chip?.label}
                                deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />}
                                onDelete={chip?.onDelete}
                              />
                            )
                          ))
                        )}
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '14px' }}>
                        <MUICancelButton title='More Filters'
                          onClick={handleOpenFillterDialog}
                          startIcon={<FilterListOutlinedIcon sx={{ fontSize: '14px !important' }} />} sx={{ color: '#6941C6', borderColor: '#D6BBFB', fontWeight: 600, width: '130px' }} />
                        {(location || technologies || mobile || email || fromDate || toDate || sourcedBy) && showClearFilter && (
                          <MUICancelButton title='Clear filter' onClick={handleclearFilterState} sx={{ width: '100px' }} />
                        )}
                      </div>
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  {/* <TableCell className='tableHeadersCell_2' >Id</TableCell> */}
                  <TableCell className="tableHeadersCell_2">
                    <Typography
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        fontSize: "12px",
                        cursor: "pointer",
                        fontWeight: 600,
                      }}
                    >
                      Name /Email
                    </Typography>
                  </TableCell>
                  <TableCell className="tableHeadersCell_2">
                    Position Name
                  </TableCell>
                  <TableCell className="tableHeadersCell_2">
                    Client Name
                  </TableCell>
                  <TableCell className="tableHeadersCell_2">
                    Candidate <br></br>
                    Sourced By
                  </TableCell>
                  <TableCell className="tableHeadersCell_2">
                    Candidate Salary/<br></br>Billing Amount
                  </TableCell>
                  <TableCell className="tableHeadersCell_2">
                    Joined Date
                  </TableCell>
                  <TableCell className="tableHeadersCell_2">
                    Event History
                  </TableCell>
                  {userRole === "admin" && (
                    <TableCell className="tableHeadersCell_2">Action</TableCell>
                  )}

                </TableRow>
              </TableHead>
              {!showTableLoader ? (
                joinedCandidateDatas?.length > 0 ? (
                  <TableBody>
                    {joinedCandidateDatas?.map((row, index) => {
                      const colors = [
                        "green",
                        "darkorange",
                        "purple",
                        "#3357FF",
                        "orangered",
                        "darkgreen",
                        "pink",
                      ];
                      const backgroundColor = colors[index % colors?.length];
                      const techNames = row?.technologies?.map((item) => {
                        return item.itemName?.trim();
                      });
                      const twoTechs = techNames?.slice(0, 2);
                      const aboveTwoTechs = techNames?.slice(2);
                      return (
                        <TableRow
                          hover
                          tabIndex={-1}
                          key={row.code}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#FAFAFA" : "inherit",
                            "&:hover": { backgroundColor: "#f1f1f1" },
                          }}
                        >
                          <TableCell
                            className="tableBodyCells"
                            onClick={() => handleCandidateNav(row)}
                            sx={{ cursor: "pointer" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "10px",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                className="tableBodyCells"
                                sx={{ color: "#181D27" }}
                              >
                                <span
                                  style={{
                                    color: "#53389E",
                                    fontWeight: 600,
                                    fontSize: "12px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  {row?.profileName}
                                  {row?.isReferralProfile !== "N" && (
                                    <MonetizationOnIcon
                                      sx={{ fontSize: "16px" }}
                                    />
                                  )}
                                </span>
                                <br />
                                <span
                                  style={{
                                    color: "#535862",
                                    fontSize: "12px",
                                  }}
                                >
                                  {row?.emailId}
                                </span>
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell
                            className="tableBodyCells"
                            sx={{ color: "#181D27", whiteSpace: "nowrap" }}
                          >
                            {row.positionName}
                            <span
                              style={{
                                color: "#5417cd",
                                fontWeight: 600,
                                marginLeft: "4px",
                              }}
                            >
                              {row?.isReferralPosition !== "N" && (
                                <MonetizationOnIcon
                                  sx={{
                                    fontSize: "16px",
                                    position: "relative",
                                    top: "5px",
                                  }}
                                />
                              )}
                            </span>{" "}
                          </TableCell>
                          <TableCell
                            className="tableBodyCells"
                            sx={{ color: "#181D27", whiteSpace: "nowrap" }}
                          >
                            {row.clientName}
                            <span
                              style={{
                                color: "#5417cd",
                                fontWeight: 600,
                                marginLeft: "4px",
                              }}
                            >
                              {row?.isReferralClient !== "N" && (
                                <MonetizationOnIcon
                                  sx={{
                                    fontSize: "16px",
                                    position: "relative",
                                    top: "5px",
                                  }}
                                />
                              )}
                            </span>{" "}
                          </TableCell>
                          <TableCell
                            className="tableBodyCells"
                          >
                            <span style={{ color: "#53389E", fontWeight: 900 }}>
                              {row?.sourceBy || "--"}
                            </span>
                          </TableCell>
                          <TableCell
                            className="tableBodyCells"
                            sx={{ color: "#181D27" }}
                          >
                            {row.candidateAnnualSalary || "NA"}
                          </TableCell>
                          <TableCell
                            className="tableBodyCells"
                            sx={{ color: "#181D27" }}
                          >
                            {row?.finalJoiningDate == "NA"
                              ? "NA"
                              : dayjs(row?.finalJoiningDate).format(
                                "DD-MM-YYYY"
                              )}
                          </TableCell>
                          <TableCell
                            className="tableBodyCells"
                            sx={{ color: "#181D27" }}
                          >
                            <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer', gap: 0.5 }} onClick={() => viewHistory(row?.profileId)}>
                              <History sx={{ fontSize: '18px', color: '#a2a2a2' }} />
                              <span style={{ fontSize: '12px', color: '#6941C6', fontWeight: 'bold' }} >View</span>
                            </Typography>
                          </TableCell>

                          {
                            userRole === "admin" && (
                              <TableCell className="tableBodyCell">
                                {
                                  row?.isReferralPosition === "N" && row?.isReferralProfile === "N" && row?.isReferralClient === "N" ? (
                                    <Typography
                                      sx={{
                                        color: '#666',
                                        fontStyle: 'italic',
                                        // width: "200px",
                                        // height: "34px",
                                        // minWidth: "160px",
                                        // display: 'flex',
                                        // justifyContent: 'center',
                                        // alignItems: 'center',
                                        fontSize: '14px'
                                      }}
                                    >
                                      Internal
                                    </Typography>
                                  ) :
                                    userRole === "admin" && (
                                      row?.positionType === "Contract" ? (
                                        <Typography
                                          sx={{
                                            color: '#666',
                                            fontStyle: 'italic',
                                            //   width: "200px",
                                            //   height: "34px",
                                            //   // minWidth: "160px",
                                            //   display: 'flex',
                                            //   justifyContent: 'center',
                                            //   alignItems: 'center',
                                            fontSize: '14px'
                                          }}
                                        >
                                          Contract
                                        </Typography>
                                      ) : (
                                        row?.isCommissionCreated === "Y" ? (
                                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            {/* <MUIButton
                                              title={"Captured"}
                                              variant="contained"
                                              startIcon={<MonetizationOnIcon />}
                                              sx={{
                                                width: "200px",
                                                height: "34px",
                                                minWidth: "160px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textTransform: "none",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                boxShadow: "none",
                                                backgroundColor: "#E0E0E0",
                                                cursor: "not-allowed",
                                              }}
                                              disabled
                                            >
                                              Captured
                                            </MUIButton> */}
                                            <Tooltip placement="top"
                                              slotProps={{
                                                tooltip: {
                                                  sx: {
                                                    backgroundColor: "#0A0D12",
                                                    borderRadius: "8px",
                                                    padding: "8px 12px",
                                                    boxShadow:
                                                      "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                  },
                                                },
                                              }}
                                              title={"Captured"}
                                            >
                                              <img src={captured} style={{ width: 25, height: 25 }} alt="Capture Commission" />
                                            </Tooltip>

                                          </div>
                                        ) : (
                                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            {/* <MUIButton
                                              title={"Capture Commission"}
                                              variant="contained"
                                              startIcon={
                                                <MonetizationOnIcon
                                                  sx={{ fontSize: '16px', mr: '2px' }}
                                                />
                                              }
                                              sx={{
                                                width: "200px",
                                                height: "32px",
                                                minWidth: "160px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textTransform: "none",
                                                fontWeight: 500,
                                                fontSize: "13px",
                                                boxShadow: "none",
                                                backgroundColor: "#6941C6",
                                                '&:hover': {
                                                  backgroundColor: "#5B36AF",
                                                },
                                              }}
                                              onClick={() => handleOpenPaymentDialog(row)}
                                            >
                                              Collect Commission Details
                                            </MUIButton> */}
                                            {(() => {
                                              const eventDatePlus30 = row?.finalJoiningDate ? dayjs(row.finalJoiningDate).add(30, 'day') : null;
                                              const isCommissionAvailable = eventDatePlus30 ? dayjs().diff(eventDatePlus30.startOf('day'), 'day') >= 0 : false;
                                              return (
                                                <Tooltip placement="top"
                                                  slotProps={{
                                                    tooltip: {
                                                      sx: {
                                                        backgroundColor: "#0A0D12",
                                                        borderRadius: "8px",
                                                        padding: "8px 12px",
                                                        boxShadow:
                                                          "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                                      },
                                                    },
                                                  }}
                                                  title={
                                                    isCommissionAvailable
                                                      ? "Capture Commission"
                                                      : "You can generate the commission after 30 days from the candidate's joining date."
                                                  }                                         >
                                                  {isCommissionAvailable ? (
                                                    <img src={salaryIcon} style={{ width: 25, height: 25, cursor: 'pointer' }} alt="Capture Commission" onClick={() => handleOpenPaymentDialog(row)} />
                                                  ) : (
                                                    <Block sx={{ color: "gray", fontSize: 20, cursor: 'not-allowed' }} />
                                                  )}
                                                </Tooltip>
                                              );
                                            })()}
                                          </div>
                                        )
                                      )
                                    )}
                              </TableCell>
                            )
                          }


                        </TableRow>
                      );
                    })}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={10}>
                        <Typography className="emptydatas">
                          No Data Found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={13}>
                    <Box className="tableloader">
                      <TableLoader />
                    </Box>
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                {counts <= joinedRowsPerPage ? (
                  ""
                ) : (
                  <TableCell colSpan={100}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <MUICancelButton
                        title="Previous"
                        startIcon={
                          <ArrowBackIcon
                            sx={{
                              color:
                                candidateJoinedPage === 1
                                  ? "#a2a2a2"
                                  : "#414651",
                            }}
                          />
                        }
                        disabled={candidateJoinedPage === 1}
                        onClick={() =>
                          handleChangeJoinedPage(null, candidateJoinedPage - 1)
                        }
                        sx={{ height: "36px" }}
                      />
                      <Pagination
                        page={candidateJoinedPage}
                        onChange={handleChangeJoinedPage}
                        count={Math.ceil(counts / joinedRowsPerPage)}
                        siblingCount={3}
                        boundaryCount={3}
                        shape="rounded"
                        hidePrevButton
                        hideNextButton
                      />

                      <MUICancelButton
                        title="Next"
                        startIcon={
                          <ArrowForwardIcon
                            sx={{
                              color:
                                candidateJoinedPage ===
                                  Math.ceil(counts / joinedRowsPerPage)
                                  ? "#a2a2a2"
                                  : "#414651",
                            }}
                          />
                        }
                        disabled={
                          candidateJoinedPage ===
                          Math.ceil(counts / joinedRowsPerPage)
                        }
                        onClick={() =>
                          handleChangeJoinedPage(null, candidateJoinedPage + 1)
                        }
                        sx={{ height: "36px" }}
                      />
                    </div>
                  </TableCell>
                )}
              </TableRow>
            </Table>
          </Paper>
        </TabPanel>
      </TabContext>
      <Grid2>
        <Dialog
          open={open}
          onClose={handleClose}
          scroll="paper"
          maxWidth="md"
          sx={{
            "& .MuiDialog-paper": {
              minHeight: "85vh",
              minWidth: "70vw",
            },
            marginLeft: "70px",
          }}
        >
          <DialogTitle variant="h6">
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
                History
              </Typography>
              <CloseIcon
                sx={{ cursor: "pointer" }}
                onClick={handleClose}
              ></CloseIcon>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="tableHeadersCell">Date </TableCell>
                    <TableCell className="tableHeadersCell">
                      Client Name{" "}
                    </TableCell>
                    <TableCell className="tableHeadersCell">
                      Job Title{" "}
                    </TableCell>
                    <TableCell className="tableHeadersCell">Event </TableCell>
                    <TableCell className="tableHeadersCell">Notes </TableCell>
                    <TableCell className="tableHeadersCell">
                      Processed By{" "}
                    </TableCell>
                    <TableCell className="tableHeadersCell">Action</TableCell>
                  </TableRow>
                </TableHead>
                {historytableLoder ? (
                  candidateHistory.length > 0 ? (
                    <TableBody>
                      {candidateHistory.map((item, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#FAFAFA" : "inherit",
                            "&:hover": { backgroundColor: "#f1f1f1" },
                          }}
                        >
                          <TableCell className="tableBodyCell">
                            {formatDate(item.date)}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item.clientName}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item.jobTitile}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item.event}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item.notes}
                          </TableCell>

                          <TableCell className="tableBodyCell">
                            {item.processedBy}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            <Tooltip
                              slotProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "#0A0D12",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    boxShadow:
                                      "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                  },
                                },
                              }}
                              title={item?.deletable ? "Delete" : ""}
                            >
                              <IconButton
                                sx={{ color: item?.deletable && "#fd5c63" }}
                                disabled={!item?.deletable}
                                onClick={(e) =>
                                  item?.deletable && hanldeMiniDialogOpen(item)
                                }
                              >
                                <DeleteIcon
                                  stroke={item?.deletable ? "red" : "#a2a2a2"}
                                  style={{
                                    cursor: !item?.deletable && "not-allowed",
                                    pointerEvents: "auto",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={10}>
                          <Typography className="emptydatas">
                            No Data Found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )
                ) : (
                  <TableCell colSpan={100}>
                    <Box className="tableloader">
                      <TableLoader />
                    </Box>
                  </TableCell>
                )}
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <MUICancelButton onClick={handleClose} title="Close">
              Close
            </MUICancelButton>
          </DialogActions>
        </Dialog>
      </Grid2>

      {/* Add job dialog box */}
      <Grid2>
        <Dialog
          className="sidePopup"
          open={openpostions}
          onClose={handleClose}
          scroll="paper"
          maxWidth="md"
        >
          <DialogTitle>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
                Select Position
              </Typography>
              <CloseIcon
                sx={{ cursor: "pointer" }}
                onClick={handleClosePosition}
              ></CloseIcon>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <div>
              <TextField
                type="text"
                placeholder="Search by position"
                value={searchQuery}
                onChange={handleSearchChange}
                className="textfields1"
                style={{ width: "100%" }}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIconLg width={20}></SearchIconLg>
                      </InputAdornment>
                    ),
                  },
                }}
              />

              {/* Displaying filtered positions */}
              {/* <div>
                {filteredPositions?.length > 0 ? (
                  filteredPositions.map((position) => (
                    <Typography
                      key={position.positionId}
                      onChange={(event) => handleCheckboxChange(event, position.positionId)}
                      sx={{ fontSize: '14px', padding: '7px', cursor: 'pointer', color: '#414651' }}
                    >
                      <Checkbox
                        value={position.positionId}
                        checked={selectedPositionIds?.includes(position.positionId)}
                        sx={{
                          '& .MuiSvgIcon-root':
                          {
                            fontSize: 18,
                            width: '20px',
                            borderRadius: '1px'
                          },
                          '&.Mui-checked': {
                            color: '#7F56D9',

                          },
                          padding: 0.5,
                        }
                        }
                      />
                      {position?.listData}
                    </Typography>
                  ))
                ) : (
                  <Typography sx={{ color: '#D5D7DA' }}>No positions found</Typography>
                )}
              </div> */}

              <div style={{ marginTop: "10px" }}>
                {filteredPositions?.length > 0 ? (
                  filteredPositions?.map(
                    (position) =>
                      position?.RewardAddedStatus === "Yes" && (
                        <Typography
                          key={position.positionId}
                          sx={{
                            fontSize: "14px",
                            cursor: "pointer",
                            color: "#414651",
                            borderRadius: "10px",
                            paddingTop: "10px",
                          }}
                        >
                          {
                            <label
                              htmlFor={`checkbox-${position.positionId}`}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              <Checkbox
                                id={`checkbox-${position.positionId}`} // Set a unique id for the checkbox
                                value={position.positionId}
                                checked={selectedPositionIds?.includes(
                                  position.positionId
                                )}
                                onChange={(event) =>
                                  handleCheckboxChange(
                                    event,
                                    position.positionId
                                  )
                                }
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 18,
                                  },
                                  padding: 0.5,
                                  marginRight: "4px",
                                }}
                              />
                              {position?.listData}
                            </label>
                          }
                        </Typography>
                      )
                  )
                ) : (
                  <Typography
                    sx={{
                      color: "#414651",
                      fontSize: "14px",
                      justifyContent: "center",
                      display: "flex",
                    }}
                  >
                    No positions found
                  </Typography>
                )}
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Grid2
              item
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              <MUICancelButton
                onClick={handleClosePosition}
                sx={{ width: "42%" }}
                title="Close"
              >
                Close
              </MUICancelButton>
              <MuiButton
                onClick={assignPositions}
                title="Apply"
                sx={{ width: "42%" }}
              ></MuiButton>
            </Grid2>
          </DialogActions>
        </Dialog>
      </Grid2>

      <Grid2 item>
        <Dialog
          open={filterDialogOpen}
          scroll="paper"
          maxWidth="md"
          className="sidePopup"
        >
          <DialogTitle
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
              Filters
            </Typography>
            <CloseIcon
              onClick={() => setFilterDialogOpen(false)}
              sx={{ cursor: "pointer" }}
            />
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid2
                container
                rowGap={2}
                sx={{ display: "flex", width: "100%" }}
              >
                {/* Container 1 */}

                {/* <Box sx={{ width: "100%" }}>
                  <InputLabel className="input"> Location </InputLabel>
                  <TextField
                    className="textfields"
                    size="small"
                    placeholder="Search By Location"
                    value={location || ""}
                    onChange={handleGetLocation}
                  />
                </Box> */}

                {/* <Box sx={{ width: "100%" }}>
                  <InputLabel className="input"> Technologies </InputLabel>
                  <TextField
                    className="textfields"
                    size="small"
                    placeholder="Search Technologies"
                    value={technologies || ""}
                    onChange={handleTechnologies}
                  />
                </Box> */}

                {/* <Box sx={{ width: "100%" }}>
                  <InputLabel className="input"> Mobile </InputLabel>
                  <TextField
                    className="textfields"
                    size="small"
                    placeholder=" Search By Mobile"
                    value={mobile || ""}
                    onChange={handleMobile}
                  />
                </Box>

                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input"> Candidate Email </InputLabel>
                  <TextField
                    className="textfields"
                    size="small"
                    placeholder="Search by Candidate Email"
                    value={email}
                    onChange={handleEmail}
                  />
                </Box> */}

                {/* <Box sx={{ width: "100%" }}>
                  <InputLabel className="input">Candidate Skills</InputLabel>
                  <Select
                    IconComponent={KeyboardArrowDownIcon}
                    className='dropdown'
                    sx={{ height: '35px', fontSize: '14px', borderRadius: '10px' }}
                    multiple
                    value={selectedKeywordIds}
                    onChange={handleCheckboxChanges}
                    displayEmpty
                    open={opencandidateSkills}
                    onOpen={() => setOpencandidateSkills(true)}
                    onClose={() => setOpencandidateSkills(false)}
                    renderValue={(selected) => selected?.length < 1
                      ? <p style={{ color: '#a2a2a2', fontSize: '14px' }}>Select Candidate Skills</p>
                      : selectedKeywords?.map((item) => item?.keywordName)?.join(', ')
                    }
                  >
                    <Box className='selectClearButton'>
                      <MenuItem value='' className="menuItemsPlaceholder" disabled>
                        Select Candidate Skills
                      </MenuItem>
                      <Tooltip title="Close" arrow>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpencandidateSkills(false);
                          }}
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          <ClearIcon sx={{ fontSize: '18px', color: '#a2a2a2' }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    {skills?.map((keyword) => (
                      <MenuItem key={keyword?.KeywordId} value={keyword?.KeywordId} sx={{ margin: '5px', borderRadius: '7px', fontSize: '14px' }}>
                        <Checkbox
                          checked={selectedKeywordIds?.includes(keyword?.KeywordId)}
                          sx={{ '& .MuiSvgIcon-root': { fontSize: 18 }, padding: 0.2 }}
                        />
                        {keyword?.keywordName}
                      </MenuItem>
                    ))}
                  </Select>
                </Box> */}

                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input">From Date</InputLabel>
                  <MuiDatePicker
                    value={fromDate}
                    onChange={hanldeFromDate}
                    slots={{
                      openPickerIcon: CalendarIcon,
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        placeholder: "Choose By From Date",
                        InputProps: {
                          sx: { borderRadius: "10px", height: "35px" },
                        },
                      },
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: "20px",
                      },
                    }}
                    format="DD-MM-YYYY"
                  />
                </Box>
                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input">To Date</InputLabel>
                  <MuiDatePicker
                    value={toDate}
                    onChange={handleTodate}
                    slots={{
                      openPickerIcon: CalendarIcon,
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        placeholder: "Choose By To Date",
                        InputProps: {
                          sx: { borderRadius: "10px", height: "35px" },
                        },
                      },
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: "20px",
                      },
                    }}
                    format="DD-MM-YYYY"
                    minDate={getNextDay(fromDate) || null}
                    maxDtae={dayjs()}
                    disabled={!fromDate}
                  />
                </Box>

                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input"> Sourced By </InputLabel>
                  <TextField
                    className="textfields"
                    size="small"
                    placeholder=" Search Sourced By"
                    value={sourcedBy || ""}
                    onChange={handleSourcedBy}
                  />
                </Box>
              </Grid2>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Grid2
              item
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              <MUICancelButton
                title="Cancel"
                sx={{ width: "42%" }}
                onClick={handleCloseFilterDialog}
              />
              <MuiButton
                title="Apply"
                sx={{ width: "42%" }}
                onClick={() => {
                  setPage(1);
                  setShouldFetch(true);
                }}
              />
            </Grid2>
          </DialogActions>
        </Dialog>

        <Grid2 item>
          <Dialog
            open={MinihistoryDialogOpen}
            scroll="paper"
            maxWidth="xs"
            sx={{
              "& .MuiDialog-paper": {
                width: "90%",
                maxWidth: "550px",
                height: "auto",
                borderRadius: "15px",
              },
            }}
          >
            <DialogContent>
              <DialogContentText>
                <div style={{ display: "flex", gap: "12px", marginTop: "7px" }}>
                  <div
                    style={{
                      backgroundColor: "#FEE4E2",
                      borderRadius: "40px",
                      height: "40px",
                      width: "45px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <DeleteIcon stroke={"red"} />
                  </div>

                  <div>
                    <Typography
                      sx={{
                        color: "#181D27",
                        fontWeight: 600,
                        fontSize: "17px",
                      }}
                    >
                      Delete Job?
                    </Typography>
                    <Typography
                      sx={{
                        color: "#535862",
                        fontWeight: 400,
                        fontSize: "14px",
                      }}
                    >
                      Are you sure you want to delete this post? This action
                      cannot be undone.
                    </Typography>
                  </div>
                </div>
                <Grid2
                  item
                  sx={{
                    marginTop: "25px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-end",
                  }}
                >
                  <MUICancelButton
                    title="Cancel"
                    onClick={() => setMinihistoryDialogOpen(false)}
                  />
                  <MUIButton
                    title="Delete"
                    sx={{
                      backgroundColor: "#D92D20",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                    onClick={deleteEventHistory}
                  />
                </Grid2>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </Grid2>
      </Grid2>

      <Grid2 item>
        <Dialog
          open={openPaymentDialog}
          scroll="paper"
          maxWidth="md"
          className="sidePopup"
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              Payment
              <CloseIcon
                sx={{ color: "#52525B", cursor: "pointer" }}
                onClick={() => setOpenPaymentDialog(false)}
              />
            </DialogTitle>
            <DialogContent dividers>
              <DialogContentText>
                <Grid2
                  item
                  container
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                  gap={2}
                >
                  <Grid2 item>
                    <InputLabel className="input"> Profile Name</InputLabel>
                    <TextField
                      className="textfields"
                      size="small"
                      placeholder="Enter Profile Name"
                      value={profileName}
                    // disabled={profileName}
                    />
                  </Grid2>

                  <Grid2 item>
                    <InputLabel className="input"> Position Name</InputLabel>
                    <TextField
                      className="textfields"
                      size="small"
                      placeholder="Enter Position Name"
                      value={positionName}
                    // disabled={positionName}
                    />
                  </Grid2>

                  <Grid2 item>
                    <InputLabel className="input">
                      {" "}
                      Candidate Joining Date{" "}
                    </InputLabel>
                    <Controller
                      control={control}
                      name="joiningDate"
                      render={({ field }) => (
                        <MuiDatePicker
                          {...field}
                          slots={{
                            openPickerIcon: CalendarIcon,
                          }}
                          slotProps={{
                            textField: {
                              size: "small",
                              placeholder: "Enter Candidate Joining Date",
                              InputProps: {
                                sx: { borderRadius: "10px", height: "35px" },
                              },
                            },
                          }}
                          sx={{
                            "& .MuiInputBase-input": {
                              fontSize: "14px",
                            },
                            "& .MuiSvgIcon-root": {
                              fontSize: "20px",
                            },
                          }}
                          format="DD-MM-YYYY"
                          minDate={dayjs()}
                        />
                      )}
                    />
                    {errors?.joiningDate?.message && (
                      <div style={{ color: "red", fontSize: "0.7rem" }}>
                        {errors?.joiningDate?.message}
                      </div>
                    )}
                  </Grid2>

                  <Grid2 item>
                    <InputLabel className="input">
                      Candidate Monthly Salary
                    </InputLabel>
                    <Controller
                      control={control}
                      name="annualSalary"
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="number"
                          className="textfields"
                          size="small"
                          placeholder="Enter Monthly salary"
                          sx={{
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              display: "none",
                            },
                          }}
                        />
                      )}
                    />
                    {errors?.annualSalary?.message && (
                      <div style={{ color: "red", fontSize: "0.7rem" }}>
                        {errors?.annualSalary?.message}
                      </div>
                    )}
                  </Grid2>
                </Grid2>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MUICancelButton
                title="Close"
                onClick={handleClosePaymentDialog}
                sx={{ borderColor: "#D6BBFB" }}
              />
              <MUIButton
                title="Submit"
                type="Submitt"
                onClose={onSubmit}
              ></MUIButton>
            </DialogActions>
          </form>
        </Dialog>
      </Grid2>

      <Grid2 item>
        <Dialog
          open={openCommissionDialog}
          onClose={handleCloseCommissionDialog}
          scroll="paper"
          maxWidth="xs"
          sx={{
            "& .MuiDialog-paper": {
              width: "90%",
              maxWidth: "500px",
              height: "auto",
              borderRadius: "15px",
              padding: "3px",
            },
          }}
        >
          <DialogTitle dividers sx={{ padding: "15px" }}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Typography sx={{ textAlign: "center", fontWeight: 600 }}>
                {message || " Commission is created for all the referrals"}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "5px",
              }}
            >
              <Typography
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                }}
              >
                {" "}
                <img
                  src={Candidate}
                  className="icons"
                  style={{ width: 25, height: 25, color: "#7F56D9" }}
                  alt="Candidate salary"
                />{" "}
                {candidateName || "-"}
              </Typography>
              <Typography
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                }}
              >
                {" "}
                <span style={{ display: "flex", alignItems: "flex-end" }}>
                  {" "}
                  {candidateSalary ? "Candidate Salary : " : "Billing Amount : "}
                  <CurrencyRupeeIcon
                    sx={{
                      fontSize: "20px !important",
                      margin: "1px !important",
                      color: "#A4A7AE",
                    }}
                  />{" "}
                  {candidateSalary ? candidateSalary : billingAmount || "-"}{" "}
                </span>{" "}
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "5px" }}
              >
                {clientCommissionAmount === 0 &&
                  jobCommissionAmount === 0 &&
                  candidateCommissionAmount === 0 && (
                    <span style={{ textAlign: "center" }}>
                      {" "}
                      No commission has been created , Thank you 🤝
                    </span>
                  )}
                {clientCommissionAmount > 0 && (
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                      }}
                    >
                      <img
                        src={handshake}
                        alt="client image "
                        style={{ width: 30, height: 30, padding: "2px" }}
                      ></img>
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                          }}
                        >
                          <Typography sx={{ color: "black" }}>
                            {" "}
                            Client Commission{" "}
                          </Typography>
                          <Typography sx={{ fontSize: "14px" }}>
                            {" "}
                            {clientRewardType === "FP"
                              ? `( ${clientRewardPercentage}% )`
                              : `( Rs.${clientRewardPercentage} )`}{" "}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", gap: "20px" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <CurrencyRupeeIcon className="icons" />{" "}
                            {clientCommissionAmount}{" "}
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <PersonIcon className="icons" />{" "}
                            <span style={{ color: "#7F56D9" }}>
                              {" "}
                              {clientCommissionAmountEarnedBy || ""}{" "}
                            </span>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )}
                {jobCommissionAmount > 0 && (
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                      }}
                    >
                      <img
                        src={Folders}
                        alt="client image "
                        style={{ width: 30, height: 30, padding: "2px" }}
                      ></img>
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                          }}
                        >
                          <Typography sx={{ color: "black" }}>
                            {" "}
                            Job Commission
                          </Typography>
                          <Typography sx={{ fontSize: "14px" }}>
                            {" "}
                            {positionRewardType === "FP"
                              ? `( ${positionRewardPercentage}% )`
                              : `( Rs.${positionRewardPercentage} )`}{" "}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", gap: "20px" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <CurrencyRupeeIcon className="icons" />{" "}
                            {jobCommissionAmount}{" "}
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <PersonIcon className="icons" />{" "}
                            <span style={{ color: "#7F56D9" }}>
                              {jobCommissionAmountEarnedBy || ""}
                            </span>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )}
                {candidateCommissionAmount > 0 && (
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                      }}
                    >
                      <img
                        src={BonusIcon}
                        alt="client image "
                        style={{ width: 30, height: 30, padding: "2px" }}
                      ></img>
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                          }}
                        >
                          <Typography sx={{ color: "black" }}>
                            {" "}
                            Candidate Commission{" "}
                          </Typography>
                          <Typography sx={{ fontSize: "14px" }}>
                            {" "}
                            {candidateRewardType === "FP"
                              ? `( ${candidateRewardPercentage}% )`
                              : `( Rs.${candidateRewardPercentage} )`}{" "}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", gap: "20px" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <CurrencyRupeeIcon className="icons" />{" "}
                            {candidateCommissionAmount}{" "}
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <PersonIcon className="icons" />
                            <span style={{ color: "#7F56D9" }}>
                              {candidateCommissionAmountEarnedBy || ""}
                            </span>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <MUICancelButton
              title="OK"
              sx={{ borderRadius: "10px" }}
              onClick={handleCloseCommissionDialog}
            />
          </DialogActions>
        </Dialog>
      </Grid2>

      <Dialog open={openContractDialog} onClose={commissionType === "" ? handleCloseInstructionDialog : handleCloseContract} maxWidth="sm" fullWidth>
        {
          commissionType === "" ? (
            <DialogContent sx={{ px: 3, pb: 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  py: 4
                }}
              >
                {/* Icon */}
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: '50%',
                    backgroundColor: 'grey.100',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2
                  }}
                >
                  <Icon>💰</Icon>
                </Box>

                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                  Commission Not Decided
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    mb: 3,
                    color: 'text.secondary',
                    maxWidth: '400px'
                  }}
                >
                  The commission amount has not been finalized with this client yet.
                  You need to set up the company commission before capturing any details.
                </Typography>

                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                  <Button
                    variant="contained"
                    onClick={handleNavToAddCommission}
                    sx={{
                      minWidth: '200px',
                      textTransform: 'none',
                    }}
                  >
                    Add Company Commission
                  </Button>

                  {/* Close Button */}
                  <Button
                    variant="outlined"
                    onClick={handleCloseInstructionDialog}
                    sx={{
                      textTransform: 'none'
                    }}
                  >
                    Close
                  </Button>
                </Box>
              </Box>
            </DialogContent>
          ) : (
            <>
              <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, pb: 1 }}>
                <Typography variant="h6" fontWeight="bold" color="#059669">
                  Candidate Information
                </Typography>
                <IconButton onClick={handleCloseContract} sx={{ marginLeft: "auto" }}>
                  <Close />
                </IconButton>
              </DialogTitle>
              <DialogContent sx={{ px: 3, pb: 4 }}>
                <Box>
                  {activeStep === 0 && (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>

                      {/* Candidate Section */}
                      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
                        <Box>
                          <InputLabel>Candidate Name <span style={{ color: 'red' }}>*</span> </InputLabel>
                          <TextField
                            size="small"
                            value={profileName}
                            disabled={positionName}
                            fullWidth
                            variant="outlined"
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '10px',
                                height: '35px',
                              },
                              '& .MuiInputBase-input.Mui-disabled': {
                                WebkitTextFillColor: '#1a1a1a', // Dark color for disabled text
                                color: '#1a1a1a', // Fallback
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#e0e0e0', // Optional: change border color when disabled
                              },
                            }}
                          />
                        </Box>

                        <Box>
                          <InputLabel>Candidate Joining Date <span style={{ color: 'red' }}>*</span> </InputLabel>
                          <Controller
                            control={control}
                            name="contractCandidateJoiningDate"
                            render={({ field }) => (
                              <MuiDatePicker
                                {...field}
                                slots={{ openPickerIcon: CalendarIcon }}
                                value={
                                  finalJoiningDate && dayjs(finalJoiningDate).isValid()
                                    ? dayjs(finalJoiningDate)
                                    : null
                                } slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                    placeholder: "Candidate Joining Date",
                                    InputProps: { sx: { borderRadius: 1 } },
                                    fullWidth: true,
                                  },
                                }}
                                disableOpenPicker={finalJoiningDate ? true : false}
                                disabled={finalJoiningDate ? true : false}
                                format="DD-MM-YYYY"
                                minDate={dayjs()}
                              />
                            )}
                          />
                          {errors?.contractCandidateJoiningDate?.message && (
                            <Typography color="error" variant="caption">
                              {errors?.contractCandidateJoiningDate?.message}
                            </Typography>
                          )}
                        </Box>

                        <Box>
                          <InputLabel>Commission Mode <span style={{ color: 'red' }}>*</span> </InputLabel>
                          <Controller
                            control={control}
                            name="commissionMode"
                            render={({ field }) => (
                              <Dropdown
                                {...field}
                                displayEmpty
                                placeholder="Select Commission Type"
                                valueKey="id"
                                labelKey="label"
                                options={commissionMode || []}
                                disabled={modeOfCommission}
                                fullWidth
                              />
                            )}
                          />
                          {errors?.commissionMode?.message && (
                            <Typography color="error" variant="caption">
                              {errors?.commissionMode?.message}
                            </Typography>
                          )}
                        </Box>

                        <Grid2>
                          <InputLabel className="input">
                            {modeOfCommission === "OTS" ? "Candidate Annual Salary" : "Candidate Monthly Salary"} <span style={{ color: 'red' }}>*</span>
                          </InputLabel>
                          <Controller
                            control={control}
                            name="candidateAnnualSalary"
                            render={({ field }) => (
                              <TextField
                                {...field}
                                type="number"
                                className="textfields"
                                size="small"
                                placeholder={modeOfCommission === "OTS" ? "Annual Salary" : "Monthly Salary"}
                                sx={{
                                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                                  {
                                    display: "none",
                                  },
                                }}
                              />
                            )}
                          />
                          {errors?.candidateAnnualSalary?.message && (
                            <div style={{ color: "red", fontSize: "0.7rem" }}>
                              {errors?.candidateAnnualSalary?.message}
                            </div>
                          )}
                        </Grid2>
                      </Box>
                      {
                        modeOfCommission !== "OTS" && (
                          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 2 }}>
                            <Box>
                              <InputLabel>Billing <span style={{ color: 'red' }}>*</span> </InputLabel>
                              <Controller
                                control={control}
                                name="billingRate"
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    type="number"
                                    size="small"
                                    placeholder="Enter Billing Rate"
                                    fullWidth
                                    sx={{
                                      '& .MuiOutlinedInput-root': {
                                        borderRadius: '10px',
                                        height: '35px'
                                      },
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                  />
                                )}
                              />
                              {errors?.billingRate?.message && (
                                <Typography color="error" variant="caption">
                                  {errors?.billingRate?.message}
                                </Typography>
                              )}
                            </Box>

                            <Box>
                              <InputLabel>Currency <span style={{ color: 'red' }}>*</span> </InputLabel>
                              <Controller
                                control={control}
                                name="units"
                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    size="small"
                                    fullWidth
                                    displayEmpty
                                    onChange={(e) => field.onChange(e.target.value)}
                                    value={field.value || ""}
                                    input={<OutlinedInput />}
                                    sx={{
                                      '& .MuiOutlinedInput-notchedOutline': {
                                        borderRadius: '10px',
                                      },
                                      '& .MuiOutlinedInput-root': {
                                        borderRadius: '10px',
                                        height: '35px',
                                      },
                                      '& .MuiSelect-select': {
                                        fontSize: '14px', // 👈 controls placeholder and selected text font size
                                        color: field.value ? '#000' : '#757575', // gray for placeholder if you want
                                      },
                                    }}
                                  >
                                    <MenuItem value="" disabled sx={{ fontSize: '14px' }}>
                                      Select Currency
                                    </MenuItem>
                                    {units.map((option) => (
                                      <MenuItem key={option.id} value={option.label} sx={{ fontSize: '14px' }}>
                                        {option.label}
                                      </MenuItem>
                                    ))}
                                  </Select>


                                )}
                              />
                              {errors?.units?.message && (
                                <Typography color="error" variant="caption">
                                  {errors.units.message}
                                </Typography>
                              )}
                            </Box>

                            <Box>
                              <InputLabel>Unit <span style={{ color: 'red' }}>*</span> </InputLabel>
                              <Controller
                                control={control}
                                name="periodOfTime"
                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    size="small"
                                    fullWidth
                                    displayEmpty
                                    onChange={(e) => field.onChange(e.target.value)}
                                    value={field.value || ""}
                                    input={<OutlinedInput />}
                                    sx={{
                                      '& .MuiOutlinedInput-notchedOutline': {
                                        borderRadius: '10px',
                                      },
                                      '& .MuiOutlinedInput-root': {
                                        borderRadius: '10px',
                                        height: '35px',
                                      },
                                      '& .MuiSelect-select': {
                                        fontSize: '14px', // 👈 controls placeholder and selected text font size
                                        color: field.value ? '#000' : '#757575', // gray for placeholder if you want
                                      },
                                    }}
                                  >
                                    <MenuItem value="" disabled sx={{ fontSize: '14px' }}>
                                      Select Unit
                                    </MenuItem>
                                    {periodOfTime.map((option) => (
                                      <MenuItem key={option.id} value={option.id}>
                                        {option.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                )}
                              />
                              {errors?.periodOfTime?.message && (
                                <Typography color="error" variant="caption">
                                  {errors.periodOfTime.message}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        )
                      }


                      {/* Commission Section */}
                      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
                        <Box>
                          <InputLabel>Company Commission Type <span style={{ color: 'red' }}>*</span> </InputLabel>
                          <Controller
                            control={control}
                            name="companyCommissionType"
                            render={({ field }) => (
                              <Dropdown
                                {...field}
                                displayEmpty
                                placeholder="Select Commission Type"
                                valueKey="id"
                                labelKey="label"
                                options={rewardTypes || []}
                                fullWidth
                                disabled={commissionType}
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                    height: '35px'
                                  },
                                }}
                              />
                            )}
                          />
                          {errors?.companyCommissionType?.message && (
                            <Typography color="error" variant="caption">
                              {errors?.companyCommissionType?.message}
                            </Typography>
                          )}
                        </Box>

                        {isAmount ? (
                          <Box>
                            <InputLabel>Commission Amount <span style={{ color: 'red' }}>*</span> </InputLabel>
                            <Controller
                              control={control}
                              name="companyCommissionAmount"
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  value={commissionAmt}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setCompanyCommissiionAmt(value);      // update your local state
                                    field.onChange(value);        // update RHF form state
                                  }}
                                  type="number"
                                  size="small"
                                  fullWidth
                                  placeholder="Enter Commission(Rs)"
                                  onWheel={(e) => e.target.blur()}
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: '10px',
                                      height: '35px'
                                    },
                                    '& .MuiInputBase-input': {
                                      fontSize: '14px',
                                      color: field.value ? '#000' : '#757575',
                                    },
                                  }}
                                />
                              )}
                            />
                            {errors?.companyCommissionAmount?.message && (
                              <Typography color="error" variant="caption">
                                {errors?.companyCommissionAmount?.message}
                              </Typography>
                            )}
                          </Box>
                        ) : (
                          <Box>
                            <InputLabel>Commission Percentage <span style={{ color: 'red' }}>*</span> </InputLabel>
                            <Controller
                              control={control}
                              name="companyCommissionPercentage"
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  type="number"
                                  size="small"
                                  fullWidth
                                  placeholder="Enter Commission(%)"
                                  onWheel={(e) => e.target.blur()}
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: '10px',
                                      height: '35px'
                                    },
                                    '& .MuiSelect-select': {
                                      fontSize: '14px', // 👈 controls placeholder and selected text font size
                                      color: field.value ? '#000' : '#757575', // gray for placeholder if you want
                                    },
                                  }}
                                />
                              )}
                            />
                            {errors?.companyCommissionPercentage?.message && (
                              <Typography color="error" variant="caption">
                                {errors?.companyCommissionPercentage?.message}
                              </Typography>
                            )}
                          </Box>
                        )}
                      </Box>

                      {
                        modeOfCommission !== "OTS" && (
                          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
                            <Box>
                              <InputLabel>Contract Open Date <span style={{ color: 'red' }}>*</span> </InputLabel>
                              <Controller
                                control={control}
                                name="contractOpenDate"
                                render={({ field }) => (
                                  <MuiDatePicker
                                    {...field}
                                    slots={{ openPickerIcon: CalendarIcon }}
                                    slotProps={{
                                      textField: { size: "small", placeholder: "Contract Open Date", fullWidth: true },
                                    }}
                                    format="DD-MM-YYYY"
                                    minDate={dayjs()}
                                  />
                                )}
                              />
                              {errors?.contractOpenDate?.message && (
                                <Typography color="error" variant="caption">
                                  {errors?.contractOpenDate?.message}
                                </Typography>
                              )}
                            </Box>
                            <Box>
                              <InputLabel>Contract Close Date <span style={{ color: 'red' }}>*</span> </InputLabel>
                              <Controller
                                control={control}
                                name="contractCloseDate"
                                render={({ field }) => (
                                  <MuiDatePicker
                                    {...field}
                                    slots={{ openPickerIcon: CalendarIcon }}
                                    slotProps={{
                                      textField: { size: "small", placeholder: "Contract Close Date", fullWidth: true },
                                    }}
                                    format="DD-MM-YYYY"
                                    minDate={dayjs(contractOpenDate)}
                                  />
                                )}
                              />
                              {errors?.contractCloseDate?.message && (
                                <Typography color="error" variant="caption">
                                  {errors?.contractCloseDate?.message}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        )
                      }

                    </Box>
                  )}

                  {activeStep === 1 && (
                    <Box>
                      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        Verify Candidate Information
                      </Typography>

                      <Box
                        sx={{
                          border: "1px solid #e0e0e0",
                          borderRadius: 2,
                          p: 3,
                          bgcolor: "#f9f9f9",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                        }}
                      >
                        <Grid2 container spacing={2}>
                          <Grid2 item xs={4}>
                            <Typography variant="caption" color="text.secondary">
                              Profile Name
                            </Typography>
                            <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                              {profileName || "-"}
                            </Typography>
                          </Grid2>
                          <Grid2 item xs={4}>
                            <Typography variant="caption" color="text.secondary">
                              Position Name
                            </Typography>
                            <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                              {positionName || "-"}
                            </Typography>
                          </Grid2>
                          <Grid2 item xs={4}>
                            <Typography variant="caption" color="text.secondary">
                              Joining Date
                            </Typography>
                            <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                              {contractCandidateJoiningDate
                                ? dayjs(contractCandidateJoiningDate).format("DD-MM-YYYY")
                                : "-"}
                            </Typography>
                          </Grid2>
                        </Grid2>

                        <Grid2 container spacing={2} sx={{ mt: 1 }}>
                          <Grid2 item xs={4}>
                            <Typography variant="caption" color="text.secondary">
                              Contract Open Date
                            </Typography>
                            <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                              {contractOpenDate
                                ? dayjs(contractOpenDate).format("DD-MM-YYYY")
                                : "-"}
                            </Typography>
                          </Grid2>
                          <Grid2 item xs={4}>
                            <Typography variant="caption" color="text.secondary">
                              Contract Close Date
                            </Typography>
                            <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                              {contractCloseDate
                                ? dayjs(contractCloseDate).format("DD-MM-YYYY")
                                : "-"}
                            </Typography>
                          </Grid2>
                          <Grid2 item xs={4}>
                            <Typography variant="caption" color="text.secondary">
                              Billing Rate
                            </Typography>
                            <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                              {currencySymbol}
                              {billingRate || "-"} / {unit}
                            </Typography>
                          </Grid2>
                        </Grid2>
                      </Box>

                      <Typography
                        variant="body2"
                        sx={{ mt: 2, color: "text.secondary", fontStyle: "italic" }}
                      >
                        Please review the details carefully before proceeding to commission.
                      </Typography>
                    </Box>
                  )}
                </Box>
                <Box sx={{ display: "flex", justifyContent: 'flex-end', mt: 4 }}>
                  <Button
                    variant="contained"
                    sx={{ bgcolor: "#059669", "&:hover": { bgcolor: "#047857" }, textTransform: 'none' }}
                    onClick={handleSubmit(handleSaveCommission)}
                  >
                    Finish
                  </Button>
                </Box>
              </DialogContent>
            </>
          )
        }
      </Dialog>

      <Grid2 item>
        <Dialog
          open={openCandidateHistory}
          onClose={handleClose}
          maxWidth="md"
          scroll="paper"
          sx={{
            "& .MuiDialog-paper": {
              minHeight: "80vh",
              minWidth: "70vw",
            },
            marginLeft: "70px",
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "18px",
              fontWeight: 600,
            }}
          >
            History
            <CloseIcon
              sx={{ color: "#52525B", cursor: "pointer" }}
              onClick={handleClose}
            />
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="tableHeadersCell">Date</TableCell>
                    <TableCell className="tableHeadersCell">
                      Client Name
                    </TableCell>
                    <TableCell className="tableHeadersCell">
                      Job Title
                    </TableCell>
                    <TableCell className="tableHeadersCell">Event</TableCell>
                    <TableCell className="tableHeadersCell">Notes</TableCell>
                    <TableCell className="tableHeadersCell">
                      Processed By
                    </TableCell>
                    <TableCell className="tableHeadersCell">Action</TableCell>
                  </TableRow>
                </TableHead>

                {historyTableDatas?.length > 0 ? (
                  <TableBody>
                    {historyTableDatas?.map((item, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          backgroundColor:
                            index % 2 === 1 ? "#FAFAFA" : "inherit",
                          "&:hover": { backgroundColor: "#f1f1f1" },
                        }}
                      >
                        <TableCell className="tableBodyCell">
                          {item?.date
                            ? dayjs(item?.date).format(
                              "DD/MM/YYYY hh:mm:ss A"
                            )
                            : "NA"}
                        </TableCell>
                        <TableCell className="tableBodyCell">
                          {item?.clientName}
                        </TableCell>
                        <TableCell className="tableBodyCell">
                          {item?.jobTitile}
                        </TableCell>
                        <TableCell className="tableBodyCell">
                          {item?.event}
                        </TableCell>
                        <TableCell className="tableBodyCell">
                          {item?.notes ? item?.notes : "NA"}
                        </TableCell>
                        <TableCell className="tableBodyCell">
                          {item?.processedBy}
                        </TableCell>
                        <TableCell className="tableBodyCell">
                          <IconButton
                            sx={{ color: item?.deletable && "#fd5c63" }}
                            disabled={!item?.deletable}
                          // onClick={() => handleOpenDelete(item)}
                          >
                            <DeleteIcon
                              stroke={item?.deletable ? "red" : "#a2a2a2"}
                              style={{
                                cursor: !item?.deletable && "not-allowed",
                                pointerEvents: "auto",
                              }}
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={8}>
                        <Typography className="emptydatas">
                          No Data Found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <MUICancelButton
              title="close"
              onClick={handleClose}
              sx={{ borderColor: "#D6BBFB" }}
            />
          </DialogActions>
        </Dialog>
      </Grid2>
    </Box >
  );
};
export default CandidateProfile;
